import "./form.css";
import d, { forwardRef as gu, useState as W, useEffect as q, useRef as J, useContext as Tt, useMemo as S, useCallback as dt, createContext as xu } from "react";
import { Checkbox as Eu, FieldError as Cu, useContextProps as Sa, TextContext as wu, LabelContext as Bu, TextField as Ra, Input as Nt, FieldErrorContext as Va, DropZone as Au, FileTrigger as Fu, Button as it, Popover as Ta, ListBoxContext as Pu, ListStateContext as ku, Radio as _u, Select as Iu, SelectValue as Mu, ComboBox as Su, ListBox as Ru, Section as Vu, Header as Tu, ListBoxItem as Nu, ComboBoxStateContext as Lu } from "react-aria-components";
import { g as K, c as fe } from "./elements.utils-DGLsBlHK.mjs";
import H from "./icon.mjs";
import { _ as Lt, $ as At, c as Ou, d as ju, e as Uu, f as Ot, g as Na, h as zu, i as Zu, j as Ku, k as Yu, l as Wu, b as qu, a as Ju, H as Hu } from "./useMultiSelectState-DttKO3du.mjs";
import { a as Ge, f as Gu, g as Qt, o as Qu, p as Ne, r as Xu, d as ei, e as La, s as ti, l as ai, i as ri, t as jt, u as ni } from "./useLocalizedStringFormatter-BVBIfLvJ.mjs";
import { b as $e, $ as j, a as Oa, d as ui, f as ii } from "./mergeProps-F8wVfzJL.mjs";
import { b as oi, $ as ja, a as li } from "./useFocusRing-44q2VWbH.mjs";
import { Gray as Qe } from "./colors.mjs";
import { R as si } from "./listbox-CKUsHS2q.mjs";
const di = "_checkbox_1ri2v_4", ci = "_box_1ri2v_18", fi = "_selectbox_1ri2v_27", ct = {
  checkbox: di,
  box: ci,
  selectbox: fi
};
function dd({ style: e, children: t, ...a }) {
  return a.className = K(
    a,
    ct.checkbox,
    e === "Selectbox" && ct.selectbox
  ), /* @__PURE__ */ d.createElement(Eu, { ...a }, /* @__PURE__ */ d.createElement("span", { className: ct.box }), /* @__PURE__ */ d.createElement(d.Fragment, null, t));
}
function ie(e) {
  switch (e) {
    case "lg":
      return "large";
    case "md":
      return "medium";
    case "sm":
      return "small";
  }
  return e.toLowerCase();
}
function oe(e, t) {
  if (!(!e || !t))
    return t[e] ? t[e] : t[ie(e)];
}
const mi = "_error_rnx9h_4", hi = "_small_rnx9h_11", $i = "_medium_rnx9h_21", yi = "_large_rnx9h_22", Xt = {
  error: mi,
  small: hi,
  medium: $i,
  large: yi
}, Be = gu(
  ({ error: e, size: t = "large", ...a }, r) => {
    const { ...n } = a;
    return n.className = K(
      a,
      Xt.error,
      oe(t, Xt)
    ), /* @__PURE__ */ d.createElement(Cu, { ...n, ref: r }, e);
  }
), bi = "_helpText_12w83_4", pi = "_small_12w83_8", Di = "_medium_12w83_18", vi = "_large_12w83_19", ea = {
  helpText: bi,
  small: pi,
  medium: Di,
  large: vi
}, pe = d.forwardRef(
  ({ size: e = "large", ...t }, a) => {
    [t, a] = Sa(t, a, wu);
    let { elementType: r = "span", ...n } = t;
    return n.className = K(
      t,
      ea.helpText,
      oe(e, ea)
    ), /* @__PURE__ */ d.createElement(r, { ...n, ref: a });
  }
), gi = "_label_x8di1_4", xi = "_small_x8di1_8", Ei = "_medium_x8di1_19", Ci = "_large_x8di1_28", ta = {
  label: gi,
  small: xi,
  medium: Ei,
  large: Ci
}, De = d.forwardRef(
  ({ size: e = "large", ...t }, a) => {
    [t, a] = Sa(t, a, Bu);
    const { elementType: r, ...n } = t;
    return n.className = K(
      t,
      ta.label,
      oe(e, ta)
    ), /* @__PURE__ */ d.createElement("label", { ...n, ref: a });
  }
), wi = "_field_ndlgt_10", Bi = "_inputWrapper_ndlgt_17", Ai = "_input_ndlgt_17", Fi = "_small_ndlgt_42", Pi = "_withLeftIcon_ndlgt_51", ki = "_icon_ndlgt_87", ve = {
  field: wi,
  inputWrapper: Bi,
  input: Ai,
  small: Fi,
  withLeftIcon: Pi,
  icon: ki
};
function cd({
  label: e,
  helpText: t,
  error: a,
  size: r,
  labelTextSize: n = r,
  ...u
}) {
  u.className = K(
    u,
    ve.field,
    oe(r, ve)
  );
  const [i, o] = W(""), [l, s] = W(0), [f, c] = W(
    "CreditCard"
  ), $ = (b) => {
    const A = b.replace(/(\s|\D)/g, ""), g = A.startsWith("34") || A.startsWith("37") ? [4, 6, 5] : [4, 4, 4, 4], x = [];
    let E = 0;
    g.forEach((_) => {
      const B = A.substring(E, E + _);
      B && x.push(B), E += _;
    });
    const F = A.substring(E);
    return F && x.push(F), x.join(" ");
  }, C = (b, A, g, x) => (
    // If more than one character was added it was a paste so move
    // the cursor ahead
    b && g > 1 || // If the cursor is at the end onf the original length or
    // it is at a space character and one character was added
    // move the cursor ahead
    (b === A || x) && g > 0
  ), w = (b) => {
    b.startsWith("4") ? c("Visa") : b.startsWith("5") || b.startsWith("2") ? c("Mastercard") : b.startsWith("6") ? c("Discover") : b.startsWith("37") || b.startsWith("34") ? c("AMEX") : c("CreditCard");
  };
  q(() => {
    u.value && i !== $(u.value) && o($(u.value));
  }, [u.value]);
  const y = (b) => {
    b.persist();
    const A = b.target.value.length, g = b.target.value.replace(/\s/g, "");
    let x = g.length - l;
    s(g.length);
    const E = $(g);
    o(E), w(E);
    const F = b.target.selectionStart, _ = F && F > 1 ? E.charAt(F - 1) === " " : !1, B = C(
      F,
      A,
      x,
      _
    ), I = B ? (F || 0) + x : F, R = B ? (b.target.selectionEnd || 0) + x : b.target.selectionEnd;
    setTimeout(() => {
      b.target.setSelectionRange(I, R);
    }, 0);
  };
  return /* @__PURE__ */ d.createElement(Ra, { ...u }, !!e && /* @__PURE__ */ d.createElement(De, { size: n }, e), !!t && /* @__PURE__ */ d.createElement(pe, { size: n, slot: "description" }, t), /* @__PURE__ */ d.createElement("div", { className: ve.inputWrapper }, /* @__PURE__ */ d.createElement("div", { className: ve.icon }, /* @__PURE__ */ d.createElement(
    H,
    {
      icon: f,
      size: ie(r || "large")
    }
  )), /* @__PURE__ */ d.createElement(
    Nt,
    {
      className: fe(ve.input, ve.withLeftIcon),
      onChange: y,
      value: i
    }
  )), /* @__PURE__ */ d.createElement(Be, { size: n, error: a }));
}
function xe(e, t) {
  return e - t * Math.floor(e / t);
}
const Ua = 1721426;
function he(e, t, a, r) {
  t = Le(e, t);
  let n = t - 1, u = -2;
  return a <= 2 ? u = 0 : ce(t) && (u = -1), Ua - 1 + 365 * n + Math.floor(n / 4) - Math.floor(n / 100) + Math.floor(n / 400) + Math.floor((367 * a - 362) / 12 + u + r);
}
function ce(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function Le(e, t) {
  return e === "BC" ? 1 - t : t;
}
function ot(e) {
  let t = "AD";
  return e <= 0 && (t = "BC", e = 1 - e), [
    t,
    e
  ];
}
const _i = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class Q {
  fromJulianDay(t) {
    let a = t, r = a - Ua, n = Math.floor(r / 146097), u = xe(r, 146097), i = Math.floor(u / 36524), o = xe(u, 36524), l = Math.floor(o / 1461), s = xe(o, 1461), f = Math.floor(s / 365), c = n * 400 + i * 100 + l * 4 + f + (i !== 4 && f !== 4 ? 1 : 0), [$, C] = ot(c), w = a - he($, C, 1, 1), y = 2;
    a < he($, C, 3, 1) ? y = 0 : ce(C) && (y = 1);
    let b = Math.floor(((w + y) * 12 + 373) / 367), A = a - he($, C, b, 1) + 1;
    return new N($, C, b, A);
  }
  toJulianDay(t) {
    return he(t.era, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    return _i[ce(t.year) ? "leapyear" : "standard"][t.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(t) {
    return 12;
  }
  getDaysInYear(t) {
    return ce(t.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(t) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(t) {
    return t.era === "BC";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BC" ? "AD" : "BC", t.year = 1 - t.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
function Ii(e) {
  return ne(Date.now(), e);
}
function za(e, t) {
  return e.calendar.toJulianDay(e) - t.calendar.toJulianDay(t);
}
function Mi(e, t) {
  return aa(e) - aa(t);
}
function aa(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let ft = null;
function Za() {
  return ft == null && (ft = new Intl.DateTimeFormat().resolvedOptions().timeZone), ft;
}
function Si(e) {
  return e.calendar.getMinimumMonthInYear ? e.calendar.getMinimumMonthInYear(e) : 1;
}
function Ri(e) {
  return e.calendar.getMinimumDayInMonth ? e.calendar.getMinimumDayInMonth(e) : 1;
}
function we(e) {
  e = U(e, new Q());
  let t = Le(e.era, e.year);
  return Ka(t, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function Ka(e, t, a, r, n, u, i) {
  let o = /* @__PURE__ */ new Date();
  return o.setUTCHours(r, n, u, i), o.setUTCFullYear(e, t - 1, a), o.getTime();
}
function Ft(e, t) {
  if (t === "UTC") return 0;
  if (e > 0 && t === Za()) return new Date(e).getTimezoneOffset() * -6e4;
  let { year: a, month: r, day: n, hour: u, minute: i, second: o } = Ya(e, t);
  return Ka(a, r, n, u, i, o, 0) - Math.floor(e / 1e3) * 1e3;
}
const ra = /* @__PURE__ */ new Map();
function Ya(e, t) {
  let a = ra.get(t);
  a || (a = new Intl.DateTimeFormat("en-US", {
    timeZone: t,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), ra.set(t, a));
  let r = a.formatToParts(new Date(e)), n = {};
  for (let u of r) u.type !== "literal" && (n[u.type] = u.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: n.era === "BC" || n.era === "B" ? -n.year + 1 : +n.year,
    month: +n.month,
    day: +n.day,
    hour: n.hour === "24" ? 0 : +n.hour,
    minute: +n.minute,
    second: +n.second
  };
}
const na = 864e5;
function Vi(e, t, a, r) {
  return (a === r ? [
    a
  ] : [
    a,
    r
  ]).filter((u) => Ti(e, t, u));
}
function Ti(e, t, a) {
  let r = Ya(a, t);
  return e.year === r.year && e.month === r.month && e.day === r.day && e.hour === r.hour && e.minute === r.minute && e.second === r.second;
}
function re(e, t, a = "compatible") {
  let r = ye(e);
  if (t === "UTC") return we(r);
  if (t === Za() && a === "compatible") {
    r = U(r, new Q());
    let l = /* @__PURE__ */ new Date(), s = Le(r.era, r.year);
    return l.setFullYear(s, r.month - 1, r.day), l.setHours(r.hour, r.minute, r.second, r.millisecond), l.getTime();
  }
  let n = we(r), u = Ft(n - na, t), i = Ft(n + na, t), o = Vi(r, t, n - u, n - i);
  if (o.length === 1) return o[0];
  if (o.length > 1) switch (a) {
    case "compatible":
    case "earlier":
      return o[0];
    case "later":
      return o[o.length - 1];
    case "reject":
      throw new RangeError("Multiple possible absolute times found");
  }
  switch (a) {
    case "earlier":
      return Math.min(n - u, n - i);
    case "compatible":
    case "later":
      return Math.max(n - u, n - i);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function Wa(e, t, a = "compatible") {
  return new Date(re(e, t, a));
}
function ne(e, t) {
  let a = Ft(e, t), r = new Date(e + a), n = r.getUTCFullYear(), u = r.getUTCMonth() + 1, i = r.getUTCDate(), o = r.getUTCHours(), l = r.getUTCMinutes(), s = r.getUTCSeconds(), f = r.getUTCMilliseconds();
  return new Te(n, u, i, t, a, o, l, s, f);
}
function Ni(e) {
  return new N(e.calendar, e.era, e.year, e.month, e.day);
}
function ye(e, t) {
  let a = 0, r = 0, n = 0, u = 0;
  if ("timeZone" in e) ({ hour: a, minute: r, second: n, millisecond: u } = e);
  else if ("hour" in e && !t) return e;
  return t && ({ hour: a, minute: r, second: n, millisecond: u } = t), new et(e.calendar, e.era, e.year, e.month, e.day, a, r, n, u);
}
function U(e, t) {
  if (e.calendar.identifier === t.identifier) return e;
  let a = t.fromJulianDay(e.calendar.toJulianDay(e)), r = e.copy();
  return r.calendar = t, r.era = a.era, r.year = a.year, r.month = a.month, r.day = a.day, be(r), r;
}
function Li(e, t, a) {
  if (e instanceof Te)
    return e.timeZone === t ? e : ji(e, t);
  let r = re(e, t, a);
  return ne(r, t);
}
function Oi(e) {
  let t = we(e) - e.offset;
  return new Date(t);
}
function ji(e, t) {
  let a = we(e) - e.offset;
  return U(ne(a, t), e.calendar);
}
const Ae = 36e5;
function lt(e, t) {
  let a = e.copy(), r = "hour" in a ? Ki(a, t) : 0;
  Pt(a, t.years || 0), a.calendar.balanceYearMonth && a.calendar.balanceYearMonth(a, e), a.month += t.months || 0, kt(a), qa(a), a.day += (t.weeks || 0) * 7, a.day += t.days || 0, a.day += r, Ui(a), a.calendar.balanceDate && a.calendar.balanceDate(a), a.year < 1 && (a.year = 1, a.month = 1, a.day = 1);
  let n = a.calendar.getYearsInEra(a);
  if (a.year > n) {
    var u, i;
    let l = (u = (i = a.calendar).isInverseEra) === null || u === void 0 ? void 0 : u.call(i, a);
    a.year = n, a.month = l ? 1 : a.calendar.getMonthsInYear(a), a.day = l ? 1 : a.calendar.getDaysInMonth(a);
  }
  a.month < 1 && (a.month = 1, a.day = 1);
  let o = a.calendar.getMonthsInYear(a);
  return a.month > o && (a.month = o, a.day = a.calendar.getDaysInMonth(a)), a.day = Math.max(1, Math.min(a.calendar.getDaysInMonth(a), a.day)), a;
}
function Pt(e, t) {
  var a, r;
  !((a = (r = e.calendar).isInverseEra) === null || a === void 0) && a.call(r, e) && (t = -t), e.year += t;
}
function kt(e) {
  for (; e.month < 1; )
    Pt(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let t = 0;
  for (; e.month > (t = e.calendar.getMonthsInYear(e)); )
    e.month -= t, Pt(e, 1);
}
function Ui(e) {
  for (; e.day < 1; )
    e.month--, kt(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, kt(e);
}
function qa(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function be(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), qa(e);
}
function Ja(e) {
  let t = {};
  for (let a in e) typeof e[a] == "number" && (t[a] = -e[a]);
  return t;
}
function Ha(e, t) {
  return lt(e, Ja(t));
}
function Ut(e, t) {
  let a = e.copy();
  return t.era != null && (a.era = t.era), t.year != null && (a.year = t.year), t.month != null && (a.month = t.month), t.day != null && (a.day = t.day), be(a), a;
}
function Xe(e, t) {
  let a = e.copy();
  return t.hour != null && (a.hour = t.hour), t.minute != null && (a.minute = t.minute), t.second != null && (a.second = t.second), t.millisecond != null && (a.millisecond = t.millisecond), Zi(a), a;
}
function zi(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Ue(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Ue(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Ue(e.minute, 60);
  let t = Math.floor(e.hour / 24);
  return e.hour = Ue(e.hour, 24), t;
}
function Zi(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Ue(e, t) {
  let a = e % t;
  return a < 0 && (a += t), a;
}
function Ki(e, t) {
  return e.hour += t.hours || 0, e.minute += t.minutes || 0, e.second += t.seconds || 0, e.millisecond += t.milliseconds || 0, zi(e);
}
function zt(e, t, a, r) {
  let n = e.copy();
  switch (t) {
    case "era": {
      let o = e.calendar.getEras(), l = o.indexOf(e.era);
      if (l < 0) throw new Error("Invalid era: " + e.era);
      l = ue(l, a, 0, o.length - 1, r == null ? void 0 : r.round), n.era = o[l], be(n);
      break;
    }
    case "year":
      var u, i;
      !((u = (i = n.calendar).isInverseEra) === null || u === void 0) && u.call(i, n) && (a = -a), n.year = ue(e.year, a, -1 / 0, 9999, r == null ? void 0 : r.round), n.year === -1 / 0 && (n.year = 1), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e);
      break;
    case "month":
      n.month = ue(e.month, a, 1, e.calendar.getMonthsInYear(e), r == null ? void 0 : r.round);
      break;
    case "day":
      n.day = ue(e.day, a, 1, e.calendar.getDaysInMonth(e), r == null ? void 0 : r.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(n), be(n), n;
}
function Ga(e, t, a, r) {
  let n = e.copy();
  switch (t) {
    case "hour": {
      let u = e.hour, i = 0, o = 23;
      if ((r == null ? void 0 : r.hourCycle) === 12) {
        let l = u >= 12;
        i = l ? 12 : 0, o = l ? 23 : 11;
      }
      n.hour = ue(u, a, i, o, r == null ? void 0 : r.round);
      break;
    }
    case "minute":
      n.minute = ue(e.minute, a, 0, 59, r == null ? void 0 : r.round);
      break;
    case "second":
      n.second = ue(e.second, a, 0, 59, r == null ? void 0 : r.round);
      break;
    case "millisecond":
      n.millisecond = ue(e.millisecond, a, 0, 999, r == null ? void 0 : r.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return n;
}
function ue(e, t, a, r, n = !1) {
  if (n) {
    e += Math.sign(t), e < a && (e = r);
    let u = Math.abs(t);
    t > 0 ? e = Math.ceil(e / u) * u : e = Math.floor(e / u) * u, e > r && (e = a);
  } else
    e += t, e < a ? e = r - (a - e - 1) : e > r && (e = a + (e - r - 1));
  return e;
}
function Qa(e, t) {
  let a;
  if (t.years != null && t.years !== 0 || t.months != null && t.months !== 0 || t.weeks != null && t.weeks !== 0 || t.days != null && t.days !== 0) {
    let n = lt(ye(e), {
      years: t.years,
      months: t.months,
      weeks: t.weeks,
      days: t.days
    });
    a = re(n, e.timeZone);
  } else
    a = we(e) - e.offset;
  a += t.milliseconds || 0, a += (t.seconds || 0) * 1e3, a += (t.minutes || 0) * 6e4, a += (t.hours || 0) * 36e5;
  let r = ne(a, e.timeZone);
  return U(r, e.calendar);
}
function Yi(e, t) {
  return Qa(e, Ja(t));
}
function Wi(e, t, a, r) {
  switch (t) {
    case "hour": {
      let n = 0, u = 23;
      if ((r == null ? void 0 : r.hourCycle) === 12) {
        let w = e.hour >= 12;
        n = w ? 12 : 0, u = w ? 23 : 11;
      }
      let i = ye(e), o = U(Xe(i, {
        hour: n
      }), new Q()), l = [
        re(o, e.timeZone, "earlier"),
        re(o, e.timeZone, "later")
      ].filter((w) => ne(w, e.timeZone).day === o.day)[0], s = U(Xe(i, {
        hour: u
      }), new Q()), f = [
        re(s, e.timeZone, "earlier"),
        re(s, e.timeZone, "later")
      ].filter((w) => ne(w, e.timeZone).day === s.day).pop(), c = we(e) - e.offset, $ = Math.floor(c / Ae), C = c % Ae;
      return c = ue($, a, Math.floor(l / Ae), Math.floor(f / Ae), r == null ? void 0 : r.round) * Ae + C, U(ne(c, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return Ga(e, t, a, r);
    case "era":
    case "year":
    case "month":
    case "day": {
      let n = zt(ye(e), t, a, r), u = re(n, e.timeZone);
      return U(ne(u, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + t);
  }
}
function qi(e, t, a) {
  let r = ye(e), n = Xe(Ut(r, t), t);
  if (n.compare(r) === 0) return e;
  let u = re(n, e.timeZone, a);
  return U(ne(u, e.timeZone), e.calendar);
}
const Ji = /^(\d{4})-(\d{2})-(\d{2})$/;
function ua(e) {
  let t = e.match(Ji);
  if (!t) throw new Error("Invalid ISO 8601 date string: " + e);
  let a = new N(mt(t[1], 0, 9999), mt(t[2], 1, 12), 1);
  return a.day = mt(t[3], 0, a.calendar.getDaysInMonth(a)), a;
}
function mt(e, t, a) {
  let r = Number(e);
  if (r < t || r > a) throw new RangeError(`Value out of range: ${t} <= ${r} <= ${a}`);
  return r;
}
function Hi(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function Xa(e) {
  let t = U(e, new Q());
  return `${String(t.year).padStart(4, "0")}-${String(t.month).padStart(2, "0")}-${String(t.day).padStart(2, "0")}`;
}
function er(e) {
  return `${Xa(e)}T${Hi(e)}`;
}
function Gi(e) {
  let t = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let a = Math.floor(e / 36e5), r = e % 36e5 / 6e4;
  return `${t}${String(a).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
}
function Qi(e) {
  return `${er(e)}${Gi(e.offset)}[${e.timeZone}]`;
}
function Zt(e) {
  let t = typeof e[0] == "object" ? e.shift() : new Q(), a;
  if (typeof e[0] == "string") a = e.shift();
  else {
    let i = t.getEras();
    a = i[i.length - 1];
  }
  let r = e.shift(), n = e.shift(), u = e.shift();
  return [
    t,
    a,
    r,
    n,
    u
  ];
}
var Xi = /* @__PURE__ */ new WeakMap();
class N {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new N(this.calendar, this.era, this.year, this.month, this.day) : new N(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(t) {
    return lt(this, t);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(t) {
    return Ha(this, t);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return Ut(this, t);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, a, r) {
    return zt(this, t, a, r);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(t) {
    return Wa(this, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return Xa(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return za(this, t);
  }
  constructor(...t) {
    Lt(this, Xi, {
      writable: !0,
      value: void 0
    });
    let [a, r, n, u, i] = Zt(t);
    this.calendar = a, this.era = r, this.year = n, this.month = u, this.day = i, be(this);
  }
}
var eo = /* @__PURE__ */ new WeakMap();
class et {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new et(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new et(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(t) {
    return lt(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return Ha(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return Ut(Xe(this, t), t);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, a, r) {
    switch (t) {
      case "era":
      case "year":
      case "month":
      case "day":
        return zt(this, t, a, r);
      default:
        return Ga(this, t, a, r);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(t, a) {
    return Wa(this, t, a);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return er(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    let a = za(this, t);
    return a === 0 ? Mi(this, ye(t)) : a;
  }
  constructor(...t) {
    Lt(this, eo, {
      writable: !0,
      value: void 0
    });
    let [a, r, n, u, i] = Zt(t);
    this.calendar = a, this.era = r, this.year = n, this.month = u, this.day = i, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, be(this);
  }
}
var to = /* @__PURE__ */ new WeakMap();
class Te {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Te(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new Te(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(t) {
    return Qa(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return Yi(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t, a) {
    return qi(this, t, a);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, a, r) {
    return Wi(this, t, a, r);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return Oi(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return Qi(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return this.toDate().getTime() - Li(t, this.timeZone).toDate().getTime();
  }
  constructor(...t) {
    Lt(this, to, {
      writable: !0,
      value: void 0
    });
    let [a, r, n, u, i] = Zt(t), o = t.shift(), l = t.shift();
    this.calendar = a, this.era = r, this.year = n, this.month = u, this.day = i, this.timeZone = o, this.offset = l, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, be(this);
  }
}
const Ee = [
  [
    1868,
    9,
    8
  ],
  [
    1912,
    7,
    30
  ],
  [
    1926,
    12,
    25
  ],
  [
    1989,
    1,
    8
  ],
  [
    2019,
    5,
    1
  ]
], ao = [
  [
    1912,
    7,
    29
  ],
  [
    1926,
    12,
    24
  ],
  [
    1989,
    1,
    7
  ],
  [
    2019,
    4,
    30
  ]
], qe = [
  1867,
  1911,
  1925,
  1988,
  2018
], de = [
  "meiji",
  "taisho",
  "showa",
  "heisei",
  "reiwa"
];
function ia(e) {
  const t = Ee.findIndex(([a, r, n]) => e.year < a || e.year === a && e.month < r || e.year === a && e.month === r && e.day < n);
  return t === -1 ? Ee.length - 1 : t === 0 ? 0 : t - 1;
}
function ht(e) {
  let t = qe[de.indexOf(e.era)];
  if (!t) throw new Error("Unknown era: " + e.era);
  return new N(e.year + t, e.month, e.day);
}
class ro extends Q {
  fromJulianDay(t) {
    let a = super.fromJulianDay(t), r = ia(a);
    return new N(this, de[r], a.year - qe[r], a.month, a.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(ht(t));
  }
  balanceDate(t) {
    let a = ht(t), r = ia(a);
    de[r] !== t.era && (t.era = de[r], t.year = a.year - qe[r]), this.constrainDate(t);
  }
  constrainDate(t) {
    let a = de.indexOf(t.era), r = ao[a];
    if (r != null) {
      let [n, u, i] = r, o = n - qe[a];
      t.year = Math.max(1, Math.min(o, t.year)), t.year === o && (t.month = Math.min(u, t.month), t.month === u && (t.day = Math.min(i, t.day)));
    }
    if (t.year === 1 && a >= 0) {
      let [, n, u] = Ee[a];
      t.month = Math.max(n, t.month), t.month === n && (t.day = Math.max(u, t.day));
    }
  }
  getEras() {
    return de;
  }
  getYearsInEra(t) {
    let a = de.indexOf(t.era), r = Ee[a], n = Ee[a + 1];
    if (n == null)
      return 9999 - r[0] + 1;
    let u = n[0] - r[0];
    return (t.month < n[1] || t.month === n[1] && t.day < n[2]) && u++, u;
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(ht(t));
  }
  getMinimumMonthInYear(t) {
    let a = oa(t);
    return a ? a[1] : 1;
  }
  getMinimumDayInMonth(t) {
    let a = oa(t);
    return a && t.month === a[1] ? a[2] : 1;
  }
  constructor(...t) {
    super(...t), this.identifier = "japanese";
  }
}
function oa(e) {
  if (e.year === 1) {
    let t = de.indexOf(e.era);
    return Ee[t];
  }
}
const tr = -543;
class no extends Q {
  fromJulianDay(t) {
    let a = super.fromJulianDay(t), r = Le(a.era, a.year);
    return new N(this, r - tr, a.month, a.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(la(t));
  }
  getEras() {
    return [
      "BE"
    ];
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(la(t));
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "buddhist";
  }
}
function la(e) {
  let [t, a] = ot(e.year + tr);
  return new N(t, a, e.month, e.day);
}
const tt = 1911;
function ar(e) {
  return e.era === "minguo" ? e.year + tt : 1 - e.year + tt;
}
function sa(e) {
  let t = e - tt;
  return t > 0 ? [
    "minguo",
    t
  ] : [
    "before_minguo",
    1 - t
  ];
}
class uo extends Q {
  fromJulianDay(t) {
    let a = super.fromJulianDay(t), r = Le(a.era, a.year), [n, u] = sa(r);
    return new N(this, n, u, a.month, a.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(da(t));
  }
  getEras() {
    return [
      "before_minguo",
      "minguo"
    ];
  }
  balanceDate(t) {
    let [a, r] = sa(ar(t));
    t.era = a, t.year = r;
  }
  isInverseEra(t) {
    return t.era === "before_minguo";
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(da(t));
  }
  getYearsInEra(t) {
    return t.era === "before_minguo" ? 9999 : 9999 - tt;
  }
  constructor(...t) {
    super(...t), this.identifier = "roc";
  }
}
function da(e) {
  let [t, a] = ot(ar(e));
  return new N(t, a, e.month, e.day);
}
const ca = 1948320, fa = [
  0,
  31,
  62,
  93,
  124,
  155,
  186,
  216,
  246,
  276,
  306,
  336
  // Esfand
];
class io {
  fromJulianDay(t) {
    let a = t - ca, r = 1 + Math.floor((33 * a + 3) / 12053), n = 365 * (r - 1) + Math.floor((8 * r + 21) / 33), u = a - n, i = u < 216 ? Math.floor(u / 31) : Math.floor((u - 6) / 30), o = u - fa[i] + 1;
    return new N(this, r, i + 1, o);
  }
  toJulianDay(t) {
    let a = ca - 1 + 365 * (t.year - 1) + Math.floor((8 * t.year + 21) / 33);
    return a += fa[t.month - 1], a += t.day, a;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInMonth(t) {
    return t.month <= 6 ? 31 : t.month <= 11 || xe(25 * t.year + 11, 33) < 8 ? 30 : 29;
  }
  getEras() {
    return [
      "AP"
    ];
  }
  getYearsInEra() {
    return 9377;
  }
  constructor() {
    this.identifier = "persian";
  }
}
const $t = 78, ma = 80;
class oo extends Q {
  fromJulianDay(t) {
    let a = super.fromJulianDay(t), r = a.year - $t, n = t - he(a.era, a.year, 1, 1), u;
    n < ma ? (r--, u = ce(a.year - 1) ? 31 : 30, n += u + 155 + 90 + 10) : (u = ce(a.year) ? 31 : 30, n -= ma);
    let i, o;
    if (n < u)
      i = 1, o = n + 1;
    else {
      let l = n - u;
      l < 155 ? (i = Math.floor(l / 31) + 2, o = l % 31 + 1) : (l -= 155, i = Math.floor(l / 30) + 7, o = l % 30 + 1);
    }
    return new N(this, r, i, o);
  }
  toJulianDay(t) {
    let a = t.year + $t, [r, n] = ot(a), u, i;
    return ce(n) ? (u = 31, i = he(r, n, 3, 21)) : (u = 30, i = he(r, n, 3, 22)), t.month === 1 ? i + t.day - 1 : (i += u + Math.min(t.month - 2, 5) * 31, t.month >= 8 && (i += (t.month - 7) * 30), i += t.day - 1, i);
  }
  getDaysInMonth(t) {
    return t.month === 1 && ce(t.year + $t) || t.month >= 2 && t.month <= 6 ? 31 : 30;
  }
  getYearsInEra() {
    return 9919;
  }
  getEras() {
    return [
      "saka"
    ];
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "indian";
  }
}
const at = 1948440, ha = 1948439, G = 1300, ge = 1600, lo = 460322;
function rt(e, t, a, r) {
  return r + Math.ceil(29.5 * (a - 1)) + (t - 1) * 354 + Math.floor((3 + 11 * t) / 30) + e - 1;
}
function rr(e, t, a) {
  let r = Math.floor((30 * (a - t) + 10646) / 10631), n = Math.min(12, Math.ceil((a - (29 + rt(t, r, 1, 1))) / 29.5) + 1), u = a - rt(t, r, n, 1) + 1;
  return new N(e, r, n, u);
}
function $a(e) {
  return (14 + 11 * e) % 30 < 11;
}
class Kt {
  fromJulianDay(t) {
    return rr(this, at, t);
  }
  toJulianDay(t) {
    return rt(at, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    let a = 29 + t.month % 2;
    return t.month === 12 && $a(t.year) && a++, a;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInYear(t) {
    return $a(t.year) ? 355 : 354;
  }
  getYearsInEra() {
    return 9665;
  }
  getEras() {
    return [
      "AH"
    ];
  }
  constructor() {
    this.identifier = "islamic-civil";
  }
}
class so extends Kt {
  fromJulianDay(t) {
    return rr(this, ha, t);
  }
  toJulianDay(t) {
    return rt(ha, t.year, t.month, t.day);
  }
  constructor(...t) {
    super(...t), this.identifier = "islamic-tbla";
  }
}
const co = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let _t, Ce;
function Je(e) {
  return lo + Ce[e - G];
}
function Ie(e, t) {
  let a = e - G, r = 1 << 11 - (t - 1);
  return _t[a] & r ? 30 : 29;
}
function ya(e, t) {
  let a = Je(e);
  for (let r = 1; r < t; r++) a += Ie(e, r);
  return a;
}
function ba(e) {
  return Ce[e + 1 - G] - Ce[e - G];
}
class fo extends Kt {
  fromJulianDay(t) {
    let a = t - at, r = Je(G), n = Je(ge);
    if (a < r || a > n) return super.fromJulianDay(t);
    {
      let u = G - 1, i = 1, o = 1;
      for (; o > 0; ) {
        u++, o = a - Je(u) + 1;
        let l = ba(u);
        if (o === l) {
          i = 12;
          break;
        } else if (o < l) {
          let s = Ie(u, i);
          for (i = 1; o > s; )
            o -= s, i++, s = Ie(u, i);
          break;
        }
      }
      return new N(this, u, i, a - ya(u, i) + 1);
    }
  }
  toJulianDay(t) {
    return t.year < G || t.year > ge ? super.toJulianDay(t) : at + ya(t.year, t.month) + (t.day - 1);
  }
  getDaysInMonth(t) {
    return t.year < G || t.year > ge ? super.getDaysInMonth(t) : Ie(t.year, t.month);
  }
  getDaysInYear(t) {
    return t.year < G || t.year > ge ? super.getDaysInYear(t) : ba(t.year);
  }
  constructor() {
    if (super(), this.identifier = "islamic-umalqura", _t || (_t = new Uint16Array(Uint8Array.from(atob(co), (t) => t.charCodeAt(0)).buffer)), !Ce) {
      Ce = new Uint32Array(ge - G + 1);
      let t = 0;
      for (let a = G; a <= ge; a++) {
        Ce[a - G] = t;
        for (let r = 1; r <= 12; r++) t += Ie(a, r);
      }
    }
  }
}
const pa = 347997, nr = 1080, ur = 24 * nr, mo = 29, ho = 12 * nr + 793, $o = mo * ur + ho;
function me(e) {
  return xe(e * 7 + 1, 19) < 7;
}
function He(e) {
  let t = Math.floor((235 * e - 234) / 19), a = 12084 + 13753 * t, r = t * 29 + Math.floor(a / 25920);
  return xe(3 * (r + 1), 7) < 3 && (r += 1), r;
}
function yo(e) {
  let t = He(e - 1), a = He(e);
  return He(e + 1) - a === 356 ? 2 : a - t === 382 ? 1 : 0;
}
function Se(e) {
  return He(e) + yo(e);
}
function ir(e) {
  return Se(e + 1) - Se(e);
}
function bo(e) {
  let t = ir(e);
  switch (t > 380 && (t -= 30), t) {
    case 353:
      return 0;
    case 354:
      return 1;
    case 355:
      return 2;
  }
}
function ze(e, t) {
  if (t >= 6 && !me(e) && t++, t === 4 || t === 7 || t === 9 || t === 11 || t === 13) return 29;
  let a = bo(e);
  return t === 2 ? a === 2 ? 30 : 29 : t === 3 ? a === 0 ? 29 : 30 : t === 6 ? me(e) ? 30 : 0 : 30;
}
class po {
  fromJulianDay(t) {
    let a = t - pa, r = a * ur / $o, n = Math.floor((19 * r + 234) / 235) + 1, u = Se(n), i = Math.floor(a - u);
    for (; i < 1; )
      n--, u = Se(n), i = Math.floor(a - u);
    let o = 1, l = 0;
    for (; l < i; )
      l += ze(n, o), o++;
    o--, l -= ze(n, o);
    let s = i - l;
    return new N(this, n, o, s);
  }
  toJulianDay(t) {
    let a = Se(t.year);
    for (let r = 1; r < t.month; r++) a += ze(t.year, r);
    return a + t.day + pa;
  }
  getDaysInMonth(t) {
    return ze(t.year, t.month);
  }
  getMonthsInYear(t) {
    return me(t.year) ? 13 : 12;
  }
  getDaysInYear(t) {
    return ir(t.year);
  }
  getYearsInEra() {
    return 9999;
  }
  getEras() {
    return [
      "AM"
    ];
  }
  balanceYearMonth(t, a) {
    a.year !== t.year && (me(a.year) && !me(t.year) && a.month > 6 ? t.month-- : !me(a.year) && me(t.year) && a.month > 6 && t.month++);
  }
  constructor() {
    this.identifier = "hebrew";
  }
}
const It = 1723856, Da = 1824665, Mt = 5500;
function nt(e, t, a, r) {
  return e + 365 * t + Math.floor(t / 4) + 30 * (a - 1) + r - 1;
}
function Yt(e, t) {
  let a = Math.floor(4 * (t - e) / 1461), r = 1 + Math.floor((t - nt(e, a, 1, 1)) / 30), n = t + 1 - nt(e, a, r, 1);
  return [
    a,
    r,
    n
  ];
}
function or(e) {
  return Math.floor(e % 4 / 3);
}
function lr(e, t) {
  return t % 13 !== 0 ? 30 : or(e) + 5;
}
class Wt {
  fromJulianDay(t) {
    let [a, r, n] = Yt(It, t), u = "AM";
    return a <= 0 && (u = "AA", a += Mt), new N(this, u, a, r, n);
  }
  toJulianDay(t) {
    let a = t.year;
    return t.era === "AA" && (a -= Mt), nt(It, a, t.month, t.day);
  }
  getDaysInMonth(t) {
    return lr(t.year, t.month);
  }
  getMonthsInYear() {
    return 13;
  }
  getDaysInYear(t) {
    return 365 + or(t.year);
  }
  getYearsInEra(t) {
    return t.era === "AA" ? 9999 : 9991;
  }
  getEras() {
    return [
      "AA",
      "AM"
    ];
  }
  constructor() {
    this.identifier = "ethiopic";
  }
}
class Do extends Wt {
  fromJulianDay(t) {
    let [a, r, n] = Yt(It, t);
    return a += Mt, new N(this, "AA", a, r, n);
  }
  getEras() {
    return [
      "AA"
    ];
  }
  getYearsInEra() {
    return 9999;
  }
  constructor(...t) {
    super(...t), this.identifier = "ethioaa";
  }
}
class vo extends Wt {
  fromJulianDay(t) {
    let [a, r, n] = Yt(Da, t), u = "CE";
    return a <= 0 && (u = "BCE", a = 1 - a), new N(this, u, a, r, n);
  }
  toJulianDay(t) {
    let a = t.year;
    return t.era === "BCE" && (a = 1 - a), nt(Da, a, t.month, t.day);
  }
  getDaysInMonth(t) {
    let a = t.year;
    return t.era === "BCE" && (a = 1 - a), lr(a, t.month);
  }
  isInverseEra(t) {
    return t.era === "BCE";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BCE" ? "CE" : "BCE", t.year = 1 - t.year);
  }
  getEras() {
    return [
      "BCE",
      "CE"
    ];
  }
  getYearsInEra(t) {
    return t.era === "BCE" ? 9999 : 9715;
  }
  constructor(...t) {
    super(...t), this.identifier = "coptic";
  }
}
function go(e) {
  switch (e) {
    case "buddhist":
      return new no();
    case "ethiopic":
      return new Wt();
    case "ethioaa":
      return new Do();
    case "coptic":
      return new vo();
    case "hebrew":
      return new po();
    case "indian":
      return new oo();
    case "islamic-civil":
      return new Kt();
    case "islamic-tbla":
      return new so();
    case "islamic-umalqura":
      return new fo();
    case "japanese":
      return new ro();
    case "persian":
      return new io();
    case "roc":
      return new uo();
    case "gregory":
    default:
      return new Q();
  }
}
let yt = /* @__PURE__ */ new Map();
class Re {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(t) {
    return this.formatter.format(t);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(t) {
    return this.formatter.formatToParts(t);
  }
  /** Formats a date range as a string. */
  formatRange(t, a) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(t, a);
    if (a < t) throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(t)} – ${this.formatter.format(a)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(t, a) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(t, a);
    if (a < t) throw new RangeError("End date must be >= start date");
    let r = this.formatter.formatToParts(t), n = this.formatter.formatToParts(a);
    return [
      ...r.map((u) => ({
        ...u,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...n.map((u) => ({
        ...u,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.formatter.resolvedOptions();
    return Co() && (this.resolvedHourCycle || (this.resolvedHourCycle = wo(t.locale, this.options)), t.hourCycle = this.resolvedHourCycle, t.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), t.calendar === "ethiopic-amete-alem" && (t.calendar = "ethioaa"), t;
  }
  constructor(t, a = {}) {
    this.formatter = sr(t, a), this.options = a;
  }
}
const xo = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function sr(e, t = {}) {
  if (typeof t.hour12 == "boolean" && Eo()) {
    t = {
      ...t
    };
    let n = xo[String(t.hour12)][e.split("-")[0]], u = t.hour12 ? "h12" : "h23";
    t.hourCycle = n ?? u, delete t.hour12;
  }
  let a = e + (t ? Object.entries(t).sort((n, u) => n[0] < u[0] ? -1 : 1).join() : "");
  if (yt.has(a)) return yt.get(a);
  let r = new Intl.DateTimeFormat(e, t);
  return yt.set(a, r), r;
}
let bt = null;
function Eo() {
  return bt == null && (bt = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), bt;
}
let pt = null;
function Co() {
  return pt == null && (pt = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), pt;
}
function wo(e, t) {
  if (!t.timeStyle && !t.hour) return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let a = sr(e, {
    ...t,
    timeZone: void 0
    // use local timezone
  }), r = parseInt(a.formatToParts(new Date(2020, 2, 3, 0)).find((u) => u.type === "hour").value, 10), n = parseInt(a.formatToParts(new Date(2020, 2, 3, 23)).find((u) => u.type === "hour").value, 10);
  if (r === 0 && n === 23) return "h23";
  if (r === 24 && n === 23) return "h24";
  if (r === 0 && n === 11) return "h11";
  if (r === 12 && n === 11) return "h12";
  throw new Error("Unexpected hour cycle result");
}
function Bo(e, t) {
  let a = e;
  for (At(a, t) && (a = a.parentElement); a && !At(a, t); ) a = a.parentElement;
  return a || document.scrollingElement || document.documentElement;
}
function Ao(e, t) {
  const a = [];
  for (; e && e !== document.documentElement; )
    At(e, t) && a.push(e), e = e.parentElement;
  return a;
}
function va(e, t, a, r) {
  let n = $e(a), u = a == null;
  q(() => {
    if (u || !e.current) return;
    let i = e.current;
    return i.addEventListener(t, n, r), () => {
      i.removeEventListener(t, n, r);
    };
  }, [
    e,
    t,
    r,
    u,
    n
  ]);
}
function Fo(e, t) {
  let a = ga(e, t, "left"), r = ga(e, t, "top"), n = t.offsetWidth, u = t.offsetHeight, i = e.scrollLeft, o = e.scrollTop, { borderTopWidth: l, borderLeftWidth: s } = getComputedStyle(e), f = e.scrollLeft + parseInt(s, 10), c = e.scrollTop + parseInt(l, 10), $ = f + e.clientWidth, C = c + e.clientHeight;
  a <= i ? i = a - parseInt(s, 10) : a + n > $ && (i += a + n - $), r <= c ? o = r - parseInt(l, 10) : r + u > C && (o += r + u - C), e.scrollLeft = i, e.scrollTop = o;
}
function ga(e, t, a) {
  const r = a === "left" ? "offsetLeft" : "offsetTop";
  let n = 0;
  for (; t.offsetParent && (n += t[r], t.offsetParent !== e); ) {
    if (t.offsetParent.contains(e)) {
      n -= e[r];
      break;
    }
    t = t.offsetParent;
  }
  return n;
}
function Po(e, t) {
  if (document.contains(e)) {
    let i = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(i).overflow === "hidden") {
      let l = Ao(e);
      for (let s of l) Fo(s, e);
    } else {
      var a;
      let { left: l, top: s } = e.getBoundingClientRect();
      e == null || (a = e.scrollIntoView) === null || a === void 0 || a.call(e, {
        block: "nearest"
      });
      let { left: f, top: c } = e.getBoundingClientRect();
      if (Math.abs(l - f) > 1 || Math.abs(s - c) > 1) {
        var r, n, u;
        t == null || (n = t.containingElement) === null || n === void 0 || (r = n.scrollIntoView) === null || r === void 0 || r.call(n, {
          block: "center",
          inline: "center"
        }), (u = e.scrollIntoView) === null || u === void 0 || u.call(e, {
          block: "nearest"
        });
      }
    }
  }
}
function ko(e, t) {
  let a = J(null);
  return e && a.current && t(e, a.current) && (e = a.current), a.current = e, e;
}
function _o(e, t, a) {
  let r = J(t), n = $e(() => {
    a && a(r.current);
  });
  q(() => {
    var u;
    let i = e == null || (u = e.current) === null || u === void 0 ? void 0 : u.form;
    return i == null || i.addEventListener("reset", n), () => {
      i == null || i.removeEventListener("reset", n);
    };
  }, [
    e,
    n
  ]);
}
function xa(e) {
  if (!e) return;
  let t = !0;
  return (a) => {
    let r = {
      ...a,
      preventDefault() {
        a.preventDefault();
      },
      isDefaultPrevented() {
        return a.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        t = !1;
      }
    };
    e(r), t && a.stopPropagation();
  };
}
function Io(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: xa(e.onKeyDown),
      onKeyUp: xa(e.onKeyUp)
    }
  };
}
function dr(e) {
  const t = Ge(e);
  if (Gu() === "virtual") {
    let a = t.activeElement;
    Ou(() => {
      t.activeElement === a && e.isConnected && Qt(e);
    });
  } else Qt(e);
}
function Mo(e) {
  const t = Qu(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement)) return !1;
  let { display: a, visibility: r } = e.style, n = a !== "none" && r !== "hidden" && r !== "collapse";
  if (n) {
    const { getComputedStyle: u } = e.ownerDocument.defaultView;
    let { display: i, visibility: o } = u(e);
    n = i !== "none" && o !== "hidden" && o !== "collapse";
  }
  return n;
}
function So(e, t) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function cr(e, t) {
  return e.nodeName !== "#comment" && Mo(e) && So(e, t) && (!e.parentElement || cr(e.parentElement, e));
}
const qt = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], Ro = qt.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
qt.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const Vo = qt.join(':not([hidden]):not([tabindex="-1"]),');
function fr(e, t) {
  return !e || !t ? !1 : t.some((a) => a.contains(e));
}
function Fe(e, t = !1) {
  if (e != null && !t) try {
    dr(e);
  } catch {
  }
  else if (e != null) try {
    e.focus();
  } catch {
  }
}
function Me(e, t, a) {
  let r = t != null && t.tabbable ? Vo : Ro, n = Ge(e).createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode(u) {
      var i;
      return !(t == null || (i = t.from) === null || i === void 0) && i.contains(u) ? NodeFilter.FILTER_REJECT : u.matches(r) && cr(u) && (!a || fr(u, a)) && (!(t != null && t.accept) || t.accept(u)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t != null && t.from && (n.currentNode = t.from), n;
}
function mr(e, t = {}) {
  return {
    focusNext(a = {}) {
      let r = e.current;
      if (!r) return null;
      let { from: n, tabbable: u = t.tabbable, wrap: i = t.wrap, accept: o = t.accept } = a, l = n || Ge(r).activeElement, s = Me(r, {
        tabbable: u,
        accept: o
      });
      r.contains(l) && (s.currentNode = l);
      let f = s.nextNode();
      return !f && i && (s.currentNode = r, f = s.nextNode()), f && Fe(f, !0), f;
    },
    focusPrevious(a = t) {
      let r = e.current;
      if (!r) return null;
      let { from: n, tabbable: u = t.tabbable, wrap: i = t.wrap, accept: o = t.accept } = a, l = n || Ge(r).activeElement, s = Me(r, {
        tabbable: u,
        accept: o
      });
      if (r.contains(l)) s.currentNode = l;
      else {
        let c = Dt(s);
        return c && Fe(c, !0), c ?? null;
      }
      let f = s.previousNode();
      if (!f && i) {
        s.currentNode = r;
        let c = Dt(s);
        if (!c)
          return null;
        f = c;
      }
      return f && Fe(f, !0), f ?? null;
    },
    focusFirst(a = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: n = t.tabbable, accept: u = t.accept } = a, o = Me(r, {
        tabbable: n,
        accept: u
      }).nextNode();
      return o && Fe(o, !0), o;
    },
    focusLast(a = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: n = t.tabbable, accept: u = t.accept } = a, i = Me(r, {
        tabbable: n,
        accept: u
      }), o = Dt(i);
      return o && Fe(o, !0), o ?? null;
    }
  };
}
function Dt(e) {
  let t, a;
  do
    a = e.lastChild(), a && (t = a);
  while (a);
  return t;
}
class Jt {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, a, r) {
    let n = this.fastMap.get(a ?? null);
    if (!n) return;
    let u = new Ea({
      scopeRef: t
    });
    n.addChild(u), u.parent = n, this.fastMap.set(t, u), r && (u.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null) return;
    let a = this.fastMap.get(t);
    if (!a) return;
    let r = a.parent;
    for (let u of this.traverse()) u !== a && a.nodeToRestore && u.nodeToRestore && a.scopeRef && a.scopeRef.current && fr(u.nodeToRestore, a.scopeRef.current) && (u.nodeToRestore = a.nodeToRestore);
    let n = a.children;
    r && (r.removeChild(a), n.size > 0 && n.forEach((u) => r && r.addChild(u))), this.fastMap.delete(a.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0) for (let a of t.children) yield* this.traverse(a);
  }
  clone() {
    var t;
    let a = new Jt();
    var r;
    for (let n of this.traverse()) a.addTreeNode(n.scopeRef, (r = (t = n.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && r !== void 0 ? r : null, n.nodeToRestore);
    return a;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new Ea({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class Ea {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
new Jt();
let To = /* @__PURE__ */ d.createContext(null);
function No(e) {
  let t = Tt(To) || {};
  ju(t, e);
  let { ref: a, ...r } = t;
  return r;
}
function Lo(e, t) {
  let { focusProps: a } = oi(e), { keyboardProps: r } = Io(e), n = j(a, r), u = No(t), i = e.isDisabled ? {} : u, o = J(e.autoFocus);
  return q(() => {
    o.current && t.current && dr(t.current), o.current = !1;
  }, [
    t
  ]), {
    focusableProps: j({
      ...n,
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }, i)
  };
}
function Ze(e) {
  e = ko(e ?? {}, Oo);
  let { locale: t } = Ne();
  return S(() => new Re(t, e), [
    t,
    e
  ]);
}
function Oo(e, t) {
  if (e === t) return !0;
  let a = Object.keys(e), r = Object.keys(t);
  if (a.length !== r.length) return !1;
  for (let n of a)
    if (t[n] !== e[n]) return !1;
  return !0;
}
let vt = /* @__PURE__ */ new Map(), St = !1;
try {
  St = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let ut = !1;
try {
  ut = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const hr = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class jo {
  /** Formats a number value as a string, according to the locale and options provided to the constructor. */
  format(t) {
    let a = "";
    if (!St && this.options.signDisplay != null ? a = zo(this.numberFormatter, this.options.signDisplay, t) : a = this.numberFormatter.format(t), this.options.style === "unit" && !ut) {
      var r;
      let { unit: n, unitDisplay: u = "short", locale: i } = this.resolvedOptions();
      if (!n) return a;
      let o = (r = hr[n]) === null || r === void 0 ? void 0 : r[u];
      a += o[i] || o.default;
    }
    return a;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, a) {
    if (typeof this.numberFormatter.formatRange == "function")
      return this.numberFormatter.formatRange(t, a);
    if (a < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(a)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, a) {
    if (typeof this.numberFormatter.formatRangeToParts == "function")
      return this.numberFormatter.formatRangeToParts(t, a);
    if (a < t) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), n = this.numberFormatter.formatToParts(a);
    return [
      ...r.map((u) => ({
        ...u,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...n.map((u) => ({
        ...u,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !St && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !ut && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
  constructor(t, a = {}) {
    this.numberFormatter = Uo(t, a), this.options = a;
  }
}
function Uo(e, t = {}) {
  let { numberingSystem: a } = t;
  if (a && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${a}`), t.style === "unit" && !ut) {
    var r;
    let { unit: i, unitDisplay: o = "short" } = t;
    if (!i) throw new Error('unit option must be provided with style: "unit"');
    if (!(!((r = hr[i]) === null || r === void 0) && r[o])) throw new Error(`Unsupported unit ${i} with unitDisplay = ${o}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let n = e + (t ? Object.entries(t).sort((i, o) => i[0] < o[0] ? -1 : 1).join() : "");
  if (vt.has(n)) return vt.get(n);
  let u = new Intl.NumberFormat(e, t);
  return vt.set(n, u), u;
}
function zo(e, t, a) {
  if (t === "auto") return e.format(a);
  if (t === "never") return e.format(Math.abs(a));
  {
    let r = !1;
    if (t === "always" ? r = a > 0 || Object.is(a, 0) : t === "exceptZero" && (Object.is(a, -0) || Object.is(a, 0) ? a = Math.abs(a) : r = a > 0), r) {
      let n = e.format(-a), u = e.format(a), i = n.replace(u, "").replace(/\u200e|\u061C/, "");
      return [
        ...i
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), n.replace(u, "!!!").replace(i, "+").replace("!!!", u);
    } else return e.format(a);
  }
}
const Zo = new RegExp("^.*\\(.*\\).*$"), Ko = [
  "latn",
  "arab",
  "hanidec"
];
class $r {
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(t) {
    return gt(this.locale, this.options, t).parse(t);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(t, a, r) {
    return gt(this.locale, this.options, t).isValidPartialNumber(t, a, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(t) {
    return gt(this.locale, this.options, t).options.numberingSystem;
  }
  constructor(t, a = {}) {
    this.locale = t, this.options = a;
  }
}
const Ca = /* @__PURE__ */ new Map();
function gt(e, t, a) {
  let r = wa(e, t);
  if (!e.includes("-nu-") && !r.isValidPartialNumber(a)) {
    for (let n of Ko) if (n !== r.options.numberingSystem) {
      let u = wa(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + n, t);
      if (u.isValidPartialNumber(a)) return u;
    }
  }
  return r;
}
function wa(e, t) {
  let a = e + (t ? Object.entries(t).sort((n, u) => n[0] < u[0] ? -1 : 1).join() : ""), r = Ca.get(a);
  return r || (r = new Yo(e, t), Ca.set(a, r)), r;
}
class Yo {
  parse(t) {
    let a = this.sanitize(t);
    if (this.symbols.group && (a = Ke(a, this.symbols.group, "")), this.symbols.decimal && (a = a.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (a = a.replace(this.symbols.minusSign, "-")), a = a.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let i = a.indexOf("-");
      a = a.replace("-", "");
      let o = a.indexOf(".");
      o === -1 && (o = a.length), a = a.replace(".", ""), o - 2 === 0 ? a = `0.${a}` : o - 2 === -1 ? a = `0.0${a}` : o - 2 === -2 ? a = "0.00" : a = `${a.slice(0, o - 2)}.${a.slice(o - 2)}`, i > -1 && (a = `-${a}`);
    }
    let r = a ? +a : NaN;
    if (isNaN(r)) return NaN;
    if (this.options.style === "percent") {
      var n, u;
      let i = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min(((n = this.options.minimumFractionDigits) !== null && n !== void 0 ? n : 0) + 2, 20),
        maximumFractionDigits: Math.min(((u = this.options.maximumFractionDigits) !== null && u !== void 0 ? u : 0) + 2, 20)
      };
      return new $r(this.locale, i).parse(new jo(this.locale, i).format(r));
    }
    return this.options.currencySign === "accounting" && Zo.test(t) && (r = -1 * r), r;
  }
  sanitize(t) {
    return t = t.replace(this.symbols.literals, ""), this.symbols.minusSign && (t = t.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (t = t.replace(",", this.symbols.decimal), t = t.replace("،", this.symbols.decimal)), this.symbols.group && (t = Ke(t, ".", this.symbols.group))), this.options.locale === "fr-FR" && (t = Ke(t, ".", " ")), t;
  }
  isValidPartialNumber(t, a = -1 / 0, r = 1 / 0) {
    return t = this.sanitize(t), this.symbols.minusSign && t.startsWith(this.symbols.minusSign) && a < 0 ? t = t.slice(this.symbols.minusSign.length) : this.symbols.plusSign && t.startsWith(this.symbols.plusSign) && r > 0 && (t = t.slice(this.symbols.plusSign.length)), this.symbols.group && t.startsWith(this.symbols.group) || this.symbols.decimal && t.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && (t = Ke(t, this.symbols.group, "")), t = t.replace(this.symbols.numeral, ""), this.symbols.decimal && (t = t.replace(this.symbols.decimal, "")), t.length === 0);
  }
  constructor(t, a = {}) {
    this.locale = t, this.formatter = new Intl.NumberFormat(t, a), this.options = this.formatter.resolvedOptions(), this.symbols = qo(t, this.formatter, this.options, a);
    var r, n;
    this.options.style === "percent" && (((r = this.options.minimumFractionDigits) !== null && r !== void 0 ? r : 0) > 18 || ((n = this.options.maximumFractionDigits) !== null && n !== void 0 ? n : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
}
const Ba = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), Wo = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function qo(e, t, a, r) {
  var n, u, i, o;
  let l = new Intl.NumberFormat(e, {
    ...a,
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21
  }), s = l.formatToParts(-10000.111), f = l.formatToParts(10000.111), c = Wo.map((m) => l.formatToParts(m));
  var $;
  let C = ($ = (n = s.find((m) => m.type === "minusSign")) === null || n === void 0 ? void 0 : n.value) !== null && $ !== void 0 ? $ : "-", w = (u = f.find((m) => m.type === "plusSign")) === null || u === void 0 ? void 0 : u.value;
  !w && ((r == null ? void 0 : r.signDisplay) === "exceptZero" || (r == null ? void 0 : r.signDisplay) === "always") && (w = "+");
  let b = (i = new Intl.NumberFormat(e, {
    ...a,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((m) => m.type === "decimal")) === null || i === void 0 ? void 0 : i.value, A = (o = s.find((m) => m.type === "group")) === null || o === void 0 ? void 0 : o.value, g = s.filter((m) => !Ba.has(m.type)).map((m) => Aa(m.value)), x = c.flatMap((m) => m.filter((h) => !Ba.has(h.type)).map((h) => Aa(h.value))), E = [
    .../* @__PURE__ */ new Set([
      ...g,
      ...x
    ])
  ].sort((m, h) => h.length - m.length), F = E.length === 0 ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${E.join("|")}|[\\p{White_Space}]`, "gu"), _ = [
    ...new Intl.NumberFormat(a.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), B = new Map(_.map((m, h) => [
    m,
    h
  ])), I = new RegExp(`[${_.join("")}]`, "g");
  return {
    minusSign: C,
    plusSign: w,
    decimal: b,
    group: A,
    literals: F,
    numeral: I,
    index: (m) => String(B.get(m))
  };
}
function Ke(e, t, a) {
  return e.replaceAll ? e.replaceAll(t, a) : e.split(t).join(a);
}
function Aa(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Jo(e) {
  let t = Uu({
    usage: "search",
    ...e
  }), a = dt((u, i) => i.length === 0 ? !0 : (u = u.normalize("NFC"), i = i.normalize("NFC"), t.compare(u.slice(0, i.length), i) === 0), [
    t
  ]), r = dt((u, i) => i.length === 0 ? !0 : (u = u.normalize("NFC"), i = i.normalize("NFC"), t.compare(u.slice(-i.length), i) === 0), [
    t
  ]), n = dt((u, i) => {
    if (i.length === 0) return !0;
    u = u.normalize("NFC"), i = i.normalize("NFC");
    let o = 0, l = i.length;
    for (; o + l <= u.length; o++) {
      let s = u.slice(o, o + l);
      if (t.compare(i, s) === 0) return !0;
    }
    return !1;
  }, [
    t
  ]);
  return S(() => ({
    startsWith: a,
    endsWith: r,
    contains: n
  }), [
    a,
    r,
    n
  ]);
}
function Ho(e, t) {
  let {
    elementType: a = "button",
    isDisabled: r,
    onPress: n,
    onPressStart: u,
    onPressEnd: i,
    onPressUp: o,
    onPressChange: l,
    preventFocusOnPress: s,
    allowFocusWhenDisabled: f,
    // @ts-ignore
    onClick: c,
    href: $,
    target: C,
    rel: w,
    type: y = "button"
  } = e, b;
  a === "button" ? b = {
    type: y,
    disabled: r
  } : b = {
    role: "button",
    tabIndex: r ? void 0 : 0,
    href: a === "a" && r ? void 0 : $,
    target: a === "a" ? C : void 0,
    type: a === "input" ? y : void 0,
    disabled: a === "input" ? r : void 0,
    "aria-disabled": !r || a === "input" ? void 0 : r,
    rel: a === "a" ? w : void 0
  };
  let { pressProps: A, isPressed: g } = Ot({
    onPressStart: u,
    onPressEnd: i,
    onPressChange: l,
    onPress: n,
    onPressUp: o,
    isDisabled: r,
    preventFocusOnPress: s,
    ref: t
  }), { focusableProps: x } = Lo(e, t);
  f && (x.tabIndex = r ? -1 : x.tabIndex);
  let E = j(x, A, Na(e, {
    labelable: !0
  }));
  return {
    isPressed: g,
    buttonProps: j(b, E, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      onClick: (F) => {
        c && (c(F), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
const yr = 7e3;
let Ve = null;
function Go(e, t = "assertive", a = yr) {
  Ve || (Ve = new Xo()), Ve.announce(e, t, a);
}
function Qo(e) {
  Ve && Ve.clear(e);
}
class Xo {
  createLog(t) {
    let a = document.createElement("div");
    return a.setAttribute("role", "log"), a.setAttribute("aria-live", t), a.setAttribute("aria-relevant", "additions"), a;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, a = "assertive", r = yr) {
    if (!this.node) return;
    let n = document.createElement("div");
    n.textContent = t, a === "assertive" ? this.assertiveLog.appendChild(n) : this.politeLog.appendChild(n), t !== "" && setTimeout(() => {
      n.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node);
  }
}
function el(e, t, a) {
  let { validationBehavior: r, focus: n } = e;
  Oa(() => {
    if (r === "native" && (a != null && a.current)) {
      let l = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      a.current.setCustomValidity(l), a.current.hasAttribute("title") || (a.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(al(a.current));
    }
  });
  let u = $e(() => {
    t.resetValidation();
  }), i = $e((l) => {
    var s;
    t.displayValidation.isInvalid || t.commitValidation();
    let f = a == null || (s = a.current) === null || s === void 0 ? void 0 : s.form;
    if (!l.defaultPrevented && a && f && rl(f) === a.current) {
      var c;
      n ? n() : (c = a.current) === null || c === void 0 || c.focus(), Xu("keyboard");
    }
    l.preventDefault();
  }), o = $e(() => {
    t.commitValidation();
  });
  q(() => {
    let l = a == null ? void 0 : a.current;
    if (!l) return;
    let s = l.form;
    return l.addEventListener("invalid", i), l.addEventListener("change", o), s == null || s.addEventListener("reset", u), () => {
      l.removeEventListener("invalid", i), l.removeEventListener("change", o), s == null || s.removeEventListener("reset", u);
    };
  }, [
    a,
    i,
    o,
    u,
    r
  ]);
}
function tl(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function al(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: tl(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function rl(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let a = e.elements[t];
    if (!a.validity.valid) return a;
  }
  return null;
}
const br = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, pr = {
  ...br,
  customError: !0,
  valid: !1
}, Pe = {
  isInvalid: !1,
  validationDetails: br,
  validationErrors: []
}, nl = xu({}), Fa = "__formValidationState" + Date.now();
function ul(e) {
  if (e[Fa]) {
    let { realtimeValidation: t, displayValidation: a, updateValidation: r, resetValidation: n, commitValidation: u } = e[Fa];
    return {
      realtimeValidation: t,
      displayValidation: a,
      updateValidation: r,
      resetValidation: n,
      commitValidation: u
    };
  }
  return il(e);
}
function il(e) {
  let { isInvalid: t, validationState: a, name: r, value: n, builtinValidation: u, validate: i, validationBehavior: o = "aria" } = e;
  a && (t || (t = a === "invalid"));
  let l = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: pr
  } : null, s = S(() => Pa(ol(i, n)), [
    i,
    n
  ]);
  u != null && u.validationDetails.valid && (u = null);
  let f = Tt(nl), c = S(() => r ? Array.isArray(r) ? r.flatMap((m) => Rt(f[m])) : Rt(f[r]) : [], [
    f,
    r
  ]), [$, C] = W(f), [w, y] = W(!1);
  f !== $ && (C(f), y(!1));
  let b = S(() => Pa(w ? [] : c), [
    w,
    c
  ]), A = J(Pe), [g, x] = W(Pe), E = J(Pe), F = () => {
    if (!_) return;
    B(!1);
    let m = s || u || A.current;
    xt(m, E.current) || (E.current = m, x(m));
  }, [_, B] = W(!1);
  return q(F), {
    realtimeValidation: l || b || s || u || Pe,
    displayValidation: o === "native" ? l || b || g : l || b || s || u || g,
    updateValidation(m) {
      o === "aria" && !xt(g, m) ? x(m) : A.current = m;
    },
    resetValidation() {
      let m = Pe;
      xt(m, E.current) || (E.current = m, x(m)), o === "native" && B(!1), y(!0);
    },
    commitValidation() {
      o === "native" && B(!0), y(!0);
    }
  };
}
function Rt(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function ol(e, t) {
  if (typeof e == "function") {
    let a = e(t);
    if (a && typeof a != "boolean") return Rt(a);
  }
  return [];
}
function Pa(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: pr
  } : null;
}
function xt(e, t) {
  return e === t ? !0 : e && t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((a, r) => a === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([a, r]) => t.validationDetails[a] === r);
}
var Dr = {};
Dr = {
  calendar: "التقويم",
  day: "يوم",
  dayPeriod: "ص/م",
  endDate: "تاريخ الانتهاء",
  era: "العصر",
  hour: "الساعات",
  minute: "الدقائق",
  month: "الشهر",
  second: "الثواني",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.startDate} إلى ${e.endDate}`,
  selectedTimeDescription: (e) => `الوقت المحدد: ${e.time}`,
  startDate: "تاريخ البدء",
  timeZoneName: "التوقيت",
  weekday: "اليوم",
  year: "السنة"
};
var vr = {};
vr = {
  calendar: "Календар",
  day: "ден",
  dayPeriod: "пр.об./сл.об.",
  endDate: "Крайна дата",
  era: "ера",
  hour: "час",
  minute: "минута",
  month: "месец",
  second: "секунда",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.startDate} до ${e.endDate}`,
  selectedTimeDescription: (e) => `Избрано време: ${e.time}`,
  startDate: "Начална дата",
  timeZoneName: "часова зона",
  weekday: "ден от седмицата",
  year: "година"
};
var gr = {};
gr = {
  calendar: "Kalendář",
  day: "den",
  dayPeriod: "část dne",
  endDate: "Konečné datum",
  era: "letopočet",
  hour: "hodina",
  minute: "minuta",
  month: "měsíc",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.startDate} až ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybraný čas: ${e.time}`,
  startDate: "Počáteční datum",
  timeZoneName: "časové pásmo",
  weekday: "den v týdnu",
  year: "rok"
};
var xr = {};
xr = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "AM/PM",
  endDate: "Slutdato",
  era: "æra",
  hour: "time",
  minute: "minut",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tidspunkt: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidszone",
  weekday: "ugedag",
  year: "år"
};
var Er = {};
Er = {
  calendar: "Kalender",
  day: "Tag",
  dayPeriod: "Tageshälfte",
  endDate: "Enddatum",
  era: "Epoche",
  hour: "Stunde",
  minute: "Minute",
  month: "Monat",
  second: "Sekunde",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.startDate} bis ${e.endDate}`,
  selectedTimeDescription: (e) => `Ausgewählte Zeit: ${e.time}`,
  startDate: "Anfangsdatum",
  timeZoneName: "Zeitzone",
  weekday: "Wochentag",
  year: "Jahr"
};
var Cr = {};
Cr = {
  calendar: "Ημερολόγιο",
  day: "ημέρα",
  dayPeriod: "π.μ./μ.μ.",
  endDate: "Ημερομηνία λήξης",
  era: "περίοδος",
  hour: "ώρα",
  minute: "λεπτό",
  month: "μήνας",
  second: "δευτερόλεπτο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.startDate} έως ${e.endDate}`,
  selectedTimeDescription: (e) => `Επιλεγμένη ώρα: ${e.time}`,
  startDate: "Ημερομηνία έναρξης",
  timeZoneName: "ζώνη ώρας",
  weekday: "καθημερινή",
  year: "έτος"
};
var wr = {};
wr = {
  era: "era",
  year: "year",
  month: "month",
  day: "day",
  hour: "hour",
  minute: "minute",
  second: "second",
  dayPeriod: "AM/PM",
  calendar: "Calendar",
  startDate: "Start Date",
  endDate: "End Date",
  weekday: "day of the week",
  timeZoneName: "time zone",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.startDate} to ${e.endDate}`,
  selectedTimeDescription: (e) => `Selected Time: ${e.time}`
};
var Br = {};
Br = {
  calendar: "Calendario",
  day: "día",
  dayPeriod: "a. m./p. m.",
  endDate: "Fecha final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mes",
  second: "segundo",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Rango seleccionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora seleccionada: ${e.time}`,
  startDate: "Fecha de inicio",
  timeZoneName: "zona horaria",
  weekday: "día de la semana",
  year: "año"
};
var Ar = {};
Ar = {
  calendar: "Kalender",
  day: "päev",
  dayPeriod: "enne/pärast lõunat",
  endDate: "Lõppkuupäev",
  era: "ajastu",
  hour: "tund",
  minute: "minut",
  month: "kuu",
  second: "sekund",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.startDate} kuni ${e.endDate}`,
  selectedTimeDescription: (e) => `Valitud aeg: ${e.time}`,
  startDate: "Alguskuupäev",
  timeZoneName: "ajavöönd",
  weekday: "nädalapäev",
  year: "aasta"
};
var Fr = {};
Fr = {
  calendar: "Kalenteri",
  day: "päivä",
  dayPeriod: "vuorokaudenaika",
  endDate: "Päättymispäivä",
  era: "aikakausi",
  hour: "tunti",
  minute: "minuutti",
  month: "kuukausi",
  second: "sekunti",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.startDate} – ${e.endDate}`,
  selectedTimeDescription: (e) => `Valittu aika: ${e.time}`,
  startDate: "Alkamispäivä",
  timeZoneName: "aikavyöhyke",
  weekday: "viikonpäivä",
  year: "vuosi"
};
var Pr = {};
Pr = {
  calendar: "Calendrier",
  day: "jour",
  dayPeriod: "cadran",
  endDate: "Date de fin",
  era: "ère",
  hour: "heure",
  minute: "minute",
  month: "mois",
  second: "seconde",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.startDate} au ${e.endDate}`,
  selectedTimeDescription: (e) => `Heure choisie : ${e.time}`,
  startDate: "Date de début",
  timeZoneName: "fuseau horaire",
  weekday: "jour de la semaine",
  year: "année"
};
var kr = {};
kr = {
  calendar: "לוח שנה",
  day: "יום",
  dayPeriod: "לפנה״צ/אחה״צ",
  endDate: "תאריך סיום",
  era: "תקופה",
  hour: "שעה",
  minute: "דקה",
  month: "חודש",
  second: "שנייה",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.startDate} עד ${e.endDate}`,
  selectedTimeDescription: (e) => `זמן נבחר: ${e.time}`,
  startDate: "תאריך התחלה",
  timeZoneName: "אזור זמן",
  weekday: "יום בשבוע",
  year: "שנה"
};
var _r = {};
_r = {
  calendar: "Kalendar",
  day: "dan",
  dayPeriod: "AM/PM",
  endDate: "Datum završetka",
  era: "era",
  hour: "sat",
  minute: "minuta",
  month: "mjesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Odabrano vrijeme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "vremenska zona",
  weekday: "dan u tjednu",
  year: "godina"
};
var Ir = {};
Ir = {
  calendar: "Naptár",
  day: "nap",
  dayPeriod: "napszak",
  endDate: "Befejező dátum",
  era: "éra",
  hour: "óra",
  minute: "perc",
  month: "hónap",
  second: "másodperc",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.startDate}–${e.endDate}`,
  selectedTimeDescription: (e) => `Kijelölt idő: ${e.time}`,
  startDate: "Kezdő dátum",
  timeZoneName: "időzóna",
  weekday: "hét napja",
  year: "év"
};
var Mr = {};
Mr = {
  calendar: "Calendario",
  day: "giorno",
  dayPeriod: "AM/PM",
  endDate: "Data finale",
  era: "era",
  hour: "ora",
  minute: "minuto",
  month: "mese",
  second: "secondo",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: da ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selezionata: ${e.time}`,
  startDate: "Data iniziale",
  timeZoneName: "fuso orario",
  weekday: "giorno della settimana",
  year: "anno"
};
var Sr = {};
Sr = {
  calendar: "カレンダー",
  day: "日",
  dayPeriod: "午前/午後",
  endDate: "終了日",
  era: "時代",
  hour: "時",
  minute: "分",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.startDate} から ${e.endDate}`,
  selectedTimeDescription: (e) => `選択した時間 : ${e.time}`,
  startDate: "開始日",
  timeZoneName: "タイムゾーン",
  weekday: "曜日",
  year: "年"
};
var Rr = {};
Rr = {
  calendar: "달력",
  day: "일",
  dayPeriod: "오전/오후",
  endDate: "종료일",
  era: "연호",
  hour: "시",
  minute: "분",
  month: "월",
  second: "초",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.startDate} ~ ${e.endDate}`,
  selectedTimeDescription: (e) => `선택 시간: ${e.time}`,
  startDate: "시작일",
  timeZoneName: "시간대",
  weekday: "요일",
  year: "년"
};
var Vr = {};
Vr = {
  calendar: "Kalendorius",
  day: "diena",
  dayPeriod: "iki pietų / po pietų",
  endDate: "Pabaigos data",
  era: "era",
  hour: "valanda",
  minute: "minutė",
  month: "mėnuo",
  second: "sekundė",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: nuo ${e.startDate} iki ${e.endDate}`,
  selectedTimeDescription: (e) => `Pasirinktas laikas: ${e.time}`,
  startDate: "Pradžios data",
  timeZoneName: "laiko juosta",
  weekday: "savaitės diena",
  year: "metai"
};
var Tr = {};
Tr = {
  calendar: "Kalendārs",
  day: "diena",
  dayPeriod: "priekšpusdienā/pēcpusdienā",
  endDate: "Beigu datums",
  era: "ēra",
  hour: "stundas",
  minute: "minūtes",
  month: "mēnesis",
  second: "sekundes",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: no ${e.startDate} līdz ${e.endDate}`,
  selectedTimeDescription: (e) => `Atlasītais laiks: ${e.time}`,
  startDate: "Sākuma datums",
  timeZoneName: "laika josla",
  weekday: "nedēļas diena",
  year: "gads"
};
var Nr = {};
Nr = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Sluttdato",
  era: "tidsalder",
  hour: "time",
  minute: "minutt",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tid: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidssone",
  weekday: "ukedag",
  year: "år"
};
var Lr = {};
Lr = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Einddatum",
  era: "tijdperk",
  hour: "uur",
  minute: "minuut",
  month: "maand",
  second: "seconde",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.startDate} tot ${e.endDate}`,
  selectedTimeDescription: (e) => `Geselecteerde tijd: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tijdzone",
  weekday: "dag van de week",
  year: "jaar"
};
var Or = {};
Or = {
  calendar: "Kalendarz",
  day: "dzień",
  dayPeriod: "rano / po południu / wieczorem",
  endDate: "Data końcowa",
  era: "era",
  hour: "godzina",
  minute: "minuta",
  month: "miesiąc",
  second: "sekunda",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Wybrany czas: ${e.time}`,
  startDate: "Data początkowa",
  timeZoneName: "strefa czasowa",
  weekday: "dzień tygodnia",
  year: "rok"
};
var jr = {};
jr = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "AM/PM",
  endDate: "Data final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data inicial",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var Ur = {};
Ur = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "am/pm",
  endDate: "Data de Término",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data de Início",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var zr = {};
zr = {
  calendar: "Calendar",
  day: "zi",
  dayPeriod: "a.m/p.m.",
  endDate: "Dată final",
  era: "eră",
  hour: "oră",
  minute: "minut",
  month: "lună",
  second: "secundă",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: de la ${e.startDate} până la ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selectată: ${e.time}`,
  startDate: "Dată început",
  timeZoneName: "fus orar",
  weekday: "ziua din săptămână",
  year: "an"
};
var Zr = {};
Zr = {
  calendar: "Календарь",
  day: "день",
  dayPeriod: "AM/PM",
  endDate: "Дата окончания",
  era: "эра",
  hour: "час",
  minute: "минута",
  month: "месяц",
  second: "секунда",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: с ${e.startDate} по ${e.endDate}`,
  selectedTimeDescription: (e) => `Выбранное время: ${e.time}`,
  startDate: "Дата начала",
  timeZoneName: "часовой пояс",
  weekday: "день недели",
  year: "год"
};
var Kr = {};
Kr = {
  calendar: "Kalendár",
  day: "deň",
  dayPeriod: "AM/PM",
  endDate: "Dátum ukončenia",
  era: "letopočet",
  hour: "hodina",
  minute: "minúta",
  month: "mesiac",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybratý čas: ${e.time}`,
  startDate: "Dátum začatia",
  timeZoneName: "časové pásmo",
  weekday: "deň týždňa",
  year: "rok"
};
var Yr = {};
Yr = {
  calendar: "Koledar",
  day: "dan",
  dayPeriod: "dop/pop",
  endDate: "Datum konca",
  era: "doba",
  hour: "ura",
  minute: "minuta",
  month: "mesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izbrani čas: ${e.time}`,
  startDate: "Datum začetka",
  timeZoneName: "časovni pas",
  weekday: "dan v tednu",
  year: "leto"
};
var Wr = {};
Wr = {
  calendar: "Kalendar",
  day: "дан",
  dayPeriod: "пре подне/по подне",
  endDate: "Datum završetka",
  era: "ера",
  hour: "сат",
  minute: "минут",
  month: "месец",
  second: "секунд",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani opseg: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izabrano vreme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "временска зона",
  weekday: "дан у недељи",
  year: "година"
};
var qr = {};
qr = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "fm/em",
  endDate: "Slutdatum",
  era: "era",
  hour: "timme",
  minute: "minut",
  month: "månad",
  second: "sekund",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.startDate} till ${e.endDate}`,
  selectedTimeDescription: (e) => `Vald tid: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tidszon",
  weekday: "veckodag",
  year: "år"
};
var Jr = {};
Jr = {
  calendar: "Takvim",
  day: "gün",
  dayPeriod: "ÖÖ/ÖS",
  endDate: "Bitiş Tarihi",
  era: "çağ",
  hour: "saat",
  minute: "dakika",
  month: "ay",
  second: "saniye",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.startDate} - ${e.endDate}`,
  selectedTimeDescription: (e) => `Seçilen Zaman: ${e.time}`,
  startDate: "Başlangıç Tarihi",
  timeZoneName: "saat dilimi",
  weekday: "haftanın günü",
  year: "yıl"
};
var Hr = {};
Hr = {
  calendar: "Календар",
  day: "день",
  dayPeriod: "дп/пп",
  endDate: "Дата завершення",
  era: "ера",
  hour: "година",
  minute: "хвилина",
  month: "місяць",
  second: "секунда",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.startDate} — ${e.endDate}`,
  selectedTimeDescription: (e) => `Вибраний час: ${e.time}`,
  startDate: "Дата початку",
  timeZoneName: "часовий пояс",
  weekday: "день тижня",
  year: "рік"
};
var Gr = {};
Gr = {
  calendar: "日历",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "结束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `选定的时间：${e.time}`,
  startDate: "开始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var Qr = {};
Qr = {
  calendar: "日曆",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "結束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `選定的時間：${e.time}`,
  startDate: "開始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var Ht = {};
Ht = {
  "ar-AE": Dr,
  "bg-BG": vr,
  "cs-CZ": gr,
  "da-DK": xr,
  "de-DE": Er,
  "el-GR": Cr,
  "en-US": wr,
  "es-ES": Br,
  "et-EE": Ar,
  "fi-FI": Fr,
  "fr-FR": Pr,
  "he-IL": kr,
  "hr-HR": _r,
  "hu-HU": Ir,
  "it-IT": Mr,
  "ja-JP": Sr,
  "ko-KR": Rr,
  "lt-LT": Vr,
  "lv-LV": Tr,
  "nb-NO": Nr,
  "nl-NL": Lr,
  "pl-PL": Or,
  "pt-BR": jr,
  "pt-PT": Ur,
  "ro-RO": zr,
  "ru-RU": Zr,
  "sk-SK": Kr,
  "sl-SI": Yr,
  "sr-SP": Wr,
  "sv-SE": qr,
  "tr-TR": Jr,
  "uk-UA": Hr,
  "zh-CN": Gr,
  "zh-TW": Qr
};
function ll(e, t, a) {
  let { direction: r } = Ne(), n = S(() => mr(t), [
    t
  ]), u = (l) => {
    if (l.currentTarget.contains(l.target) && (l.altKey && (l.key === "ArrowDown" || l.key === "ArrowUp") && "setOpen" in e && (l.preventDefault(), l.stopPropagation(), e.setOpen(!0)), !a))
      switch (l.key) {
        case "ArrowLeft":
          l.preventDefault(), l.stopPropagation(), r === "rtl" ? n.focusNext() : n.focusPrevious();
          break;
        case "ArrowRight":
          l.preventDefault(), l.stopPropagation(), r === "rtl" ? n.focusPrevious() : n.focusNext();
          break;
      }
  }, i = () => {
    var l;
    let s = (l = window.event) === null || l === void 0 ? void 0 : l.target, f = Me(t.current, {
      tabbable: !0
    });
    if (s && (f.currentNode = s, s = f.previousNode()), !s) {
      let c;
      do
        c = f.lastChild(), c && (s = c);
      while (c);
    }
    for (; s != null && s.hasAttribute("data-placeholder"); ) {
      let c = f.previousNode();
      if (c && c.hasAttribute("data-placeholder")) s = c;
      else break;
    }
    s && s.focus();
  }, { pressProps: o } = Ot({
    preventFocusOnPress: !0,
    allowTextSelectionOnPress: !0,
    onPressStart(l) {
      l.pointerType === "mouse" && i();
    },
    onPress(l) {
      l.pointerType !== "mouse" && i();
    }
  });
  return j(o, {
    onKeyDown: u
  });
}
function sl(e) {
  return e && e.__esModule ? e.default : e;
}
const Xr = /* @__PURE__ */ new WeakMap(), Et = "__role_" + Date.now(), dl = "__focusManager_" + Date.now();
function cl(e, t, a) {
  var r;
  let { isInvalid: n, validationErrors: u, validationDetails: i } = t.displayValidation, { labelProps: o, fieldProps: l, descriptionProps: s, errorMessageProps: f } = zu({
    ...e,
    labelElementType: "span",
    isInvalid: n,
    errorMessage: e.errorMessage || u
  }), c = J(null), { focusWithinProps: $ } = ei({
    ...e,
    onFocusWithin(m) {
      var h;
      c.current = t.value, (h = e.onFocus) === null || h === void 0 || h.call(e, m);
    },
    onBlurWithin: (m) => {
      var h;
      t.confirmPlaceholder(), t.value !== c.current && t.commitValidation(), (h = e.onBlur) === null || h === void 0 || h.call(e, m);
    },
    onFocusWithinChange: e.onFocusChange
  }), C = La(sl(Ht), "@react-aria/datepicker"), w = t.maxGranularity === "hour" ? "selectedTimeDescription" : "selectedDateDescription", y = t.maxGranularity === "hour" ? "time" : "date", b = t.value ? C.format(w, {
    [y]: t.formatValue({
      month: "long"
    })
  }) : "", A = Zu(b), g = e[Et] === "presentation" ? l["aria-describedby"] : [
    A["aria-describedby"],
    l["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, x = e[dl], E = S(() => x || mr(a), [
    x,
    a
  ]), F = ll(t, a, e[Et] === "presentation");
  Xr.set(t, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: [
      o.id,
      e["aria-labelledby"]
    ].filter(Boolean).join(" ") || void 0,
    ariaDescribedBy: g,
    focusManager: E
  });
  let _ = J(e.autoFocus), B;
  e[Et] === "presentation" ? B = {
    role: "presentation"
  } : B = j(l, {
    role: "group",
    "aria-disabled": e.isDisabled || void 0,
    "aria-describedby": g
  }), q(() => {
    _.current && E.focusFirst(), _.current = !1;
  }, [
    E
  ]), _o(e.inputRef, t.value, t.setValue), el({
    ...e,
    focus() {
      E.focusFirst();
    }
  }, t, e.inputRef);
  let I = {
    type: "hidden",
    name: e.name,
    value: ((r = t.value) === null || r === void 0 ? void 0 : r.toString()) || ""
  };
  e.validationBehavior === "native" && (I.type = "text", I.hidden = !0, I.required = e.isRequired, I.onChange = () => {
  });
  let R = Na(e);
  return {
    labelProps: {
      ...o,
      onClick: () => {
        E.focusFirst();
      }
    },
    fieldProps: j(R, B, F, $, {
      onKeyDown(m) {
        e.onKeyDown && e.onKeyDown(m);
      },
      onKeyUp(m) {
        e.onKeyUp && e.onKeyUp(m);
      }
    }),
    inputProps: I,
    descriptionProps: s,
    errorMessageProps: f,
    isInvalid: n,
    validationErrors: u,
    validationDetails: i
  };
}
function fl(e) {
  return e && e.__esModule ? e.default : e;
}
function ml() {
  let { locale: e } = Ne(), t = ti(fl(Ht), "@react-aria/datepicker");
  return S(() => {
    try {
      return new Intl.DisplayNames(e, {
        type: "dateTimeField"
      });
    } catch {
      return new hl(e, t);
    }
  }, [
    e,
    t
  ]);
}
class hl {
  of(t) {
    return this.dictionary.getStringForLocale(t, this.locale);
  }
  constructor(t, a) {
    this.locale = t, this.dictionary = a;
  }
}
var en = {};
en = {
  Empty: "فارغ"
};
var tn = {};
tn = {
  Empty: "Изпразни"
};
var an = {};
an = {
  Empty: "Prázdné"
};
var rn = {};
rn = {
  Empty: "Tom"
};
var nn = {};
nn = {
  Empty: "Leer"
};
var un = {};
un = {
  Empty: "Άδειο"
};
var on = {};
on = {
  Empty: "Empty"
};
var ln = {};
ln = {
  Empty: "Vacío"
};
var sn = {};
sn = {
  Empty: "Tühjenda"
};
var dn = {};
dn = {
  Empty: "Tyhjä"
};
var cn = {};
cn = {
  Empty: "Vide"
};
var fn = {};
fn = {
  Empty: "ריק"
};
var mn = {};
mn = {
  Empty: "Prazno"
};
var hn = {};
hn = {
  Empty: "Üres"
};
var $n = {};
$n = {
  Empty: "Vuoto"
};
var yn = {};
yn = {
  Empty: "空"
};
var bn = {};
bn = {
  Empty: "비어 있음"
};
var pn = {};
pn = {
  Empty: "Tuščias"
};
var Dn = {};
Dn = {
  Empty: "Tukšs"
};
var vn = {};
vn = {
  Empty: "Tom"
};
var gn = {};
gn = {
  Empty: "Leeg"
};
var xn = {};
xn = {
  Empty: "Pusty"
};
var En = {};
En = {
  Empty: "Vazio"
};
var Cn = {};
Cn = {
  Empty: "Vazio"
};
var wn = {};
wn = {
  Empty: "Gol"
};
var Bn = {};
Bn = {
  Empty: "Не заполнено"
};
var An = {};
An = {
  Empty: "Prázdne"
};
var Fn = {};
Fn = {
  Empty: "Prazen"
};
var Pn = {};
Pn = {
  Empty: "Prazno"
};
var kn = {};
kn = {
  Empty: "Tomt"
};
var _n = {};
_n = {
  Empty: "Boş"
};
var In = {};
In = {
  Empty: "Пусто"
};
var Mn = {};
Mn = {
  Empty: "空"
};
var Sn = {};
Sn = {
  Empty: "空白"
};
var Rn = {};
Rn = {
  "ar-AE": en,
  "bg-BG": tn,
  "cs-CZ": an,
  "da-DK": rn,
  "de-DE": nn,
  "el-GR": un,
  "en-US": on,
  "es-ES": ln,
  "et-EE": sn,
  "fi-FI": dn,
  "fr-FR": cn,
  "he-IL": fn,
  "hr-HR": mn,
  "hu-HU": hn,
  "it-IT": $n,
  "ja-JP": yn,
  "ko-KR": bn,
  "lt-LT": pn,
  "lv-LV": Dn,
  "nb-NO": vn,
  "nl-NL": gn,
  "pl-PL": xn,
  "pt-BR": En,
  "pt-PT": Cn,
  "ro-RO": wn,
  "ru-RU": Bn,
  "sk-SK": An,
  "sl-SI": Fn,
  "sr-SP": Pn,
  "sv-SE": kn,
  "tr-TR": _n,
  "uk-UA": In,
  "zh-CN": Mn,
  "zh-TW": Sn
};
function $l(e) {
  return e && e.__esModule ? e.default : e;
}
function yl(e) {
  const t = J();
  let { value: a, textValue: r, minValue: n, maxValue: u, isDisabled: i, isReadOnly: o, isRequired: l, onIncrement: s, onIncrementPage: f, onDecrement: c, onDecrementPage: $, onDecrementToMin: C, onIncrementToMax: w } = e;
  const y = La($l(Rn), "@react-aria/spinbutton"), b = () => clearTimeout(t.current);
  q(() => () => b(), []);
  let A = (h) => {
    if (!(h.ctrlKey || h.metaKey || h.shiftKey || h.altKey || o))
      switch (h.key) {
        case "PageUp":
          if (f) {
            h.preventDefault(), f == null || f();
            break;
          }
        case "ArrowUp":
        case "Up":
          s && (h.preventDefault(), s == null || s());
          break;
        case "PageDown":
          if ($) {
            h.preventDefault(), $ == null || $();
            break;
          }
        case "ArrowDown":
        case "Down":
          c && (h.preventDefault(), c == null || c());
          break;
        case "Home":
          C && (h.preventDefault(), C == null || C());
          break;
        case "End":
          w && (h.preventDefault(), w == null || w());
          break;
      }
  }, g = J(!1), x = () => {
    g.current = !0;
  }, E = () => {
    g.current = !1;
  }, F = r === "" ? y.format("Empty") : (r || `${a}`).replace("-", "−");
  q(() => {
    g.current && (Qo("assertive"), Go(F, "assertive"));
  }, [
    F
  ]);
  const _ = $e((h) => {
    b(), s == null || s(), t.current = window.setTimeout(() => {
      (u === void 0 || isNaN(u) || a === void 0 || isNaN(a) || a < u) && _(60);
    }, h);
  }), B = $e((h) => {
    b(), c == null || c(), t.current = window.setTimeout(() => {
      (n === void 0 || isNaN(n) || a === void 0 || isNaN(a) || a > n) && B(60);
    }, h);
  });
  let I = (h) => {
    h.preventDefault();
  }, { addGlobalListener: R, removeAllGlobalListeners: m } = Ku();
  return {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": a !== void 0 && !isNaN(a) ? a : void 0,
      "aria-valuetext": F,
      "aria-valuemin": n,
      "aria-valuemax": u,
      "aria-disabled": i || void 0,
      "aria-readonly": o || void 0,
      "aria-required": l || void 0,
      onKeyDown: A,
      onFocus: x,
      onBlur: E
    },
    incrementButtonProps: {
      onPressStart: () => {
        _(400), R(window, "contextmenu", I);
      },
      onPressEnd: () => {
        b(), m();
      },
      onFocus: x,
      onBlur: E
    },
    decrementButtonProps: {
      onPressStart: () => {
        B(400), R(window, "contextmenu", I);
      },
      onPressEnd: () => {
        b(), m();
      },
      onFocus: x,
      onBlur: E
    }
  };
}
function bl(e, t, a) {
  let r = J(""), { locale: n } = Ne(), u = ml(), { ariaLabel: i, ariaLabelledBy: o, ariaDescribedBy: l, focusManager: s } = Xr.get(t), f = e.isPlaceholder ? "" : e.text, c = S(() => t.dateFormatter.resolvedOptions(), [
    t.dateFormatter
  ]), $ = Ze({
    month: "long",
    timeZone: c.timeZone
  }), C = Ze({
    hour: "numeric",
    hour12: c.hour12,
    timeZone: c.timeZone
  });
  if (e.type === "month" && !e.isPlaceholder) {
    let p = $.format(t.dateValue);
    f = p !== f ? `${f} – ${p}` : p;
  } else e.type === "hour" && !e.isPlaceholder && (f = C.format(t.dateValue));
  let { spinButtonProps: w } = yl({
    // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
    // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
    // https://github.com/dequelabs/axe-core/issues/3505
    value: e.value,
    textValue: f,
    minValue: e.minValue,
    maxValue: e.maxValue,
    isDisabled: t.isDisabled,
    isReadOnly: t.isReadOnly || !e.isEditable,
    isRequired: t.isRequired,
    onIncrement: () => {
      r.current = "", t.increment(e.type);
    },
    onDecrement: () => {
      r.current = "", t.decrement(e.type);
    },
    onIncrementPage: () => {
      r.current = "", t.incrementPage(e.type);
    },
    onDecrementPage: () => {
      r.current = "", t.decrementPage(e.type);
    },
    onIncrementToMax: () => {
      r.current = "", t.setSegment(e.type, e.maxValue);
    },
    onDecrementToMin: () => {
      r.current = "", t.setSegment(e.type, e.minValue);
    }
  }), y = S(() => new $r(n, {
    maximumFractionDigits: 0
  }), [
    n
  ]), b = () => {
    if (e.text === e.placeholder && s.focusPrevious(), y.isValidPartialNumber(e.text) && !t.isReadOnly && !e.isPlaceholder) {
      let p = e.text.slice(0, -1), M = y.parse(p);
      p = M === 0 ? "" : p, p.length === 0 || M === 0 ? t.clearSegment(e.type) : t.setSegment(e.type, M), r.current = p;
    } else e.type === "dayPeriod" && t.clearSegment(e.type);
  }, A = (p) => {
    if (p.key === "a" && (ri() ? p.metaKey : p.ctrlKey) && p.preventDefault(), !(p.ctrlKey || p.metaKey || p.shiftKey || p.altKey))
      switch (p.key) {
        case "Backspace":
        case "Delete":
          p.preventDefault(), p.stopPropagation(), b();
          break;
      }
  }, { startsWith: g } = Jo({
    sensitivity: "base"
  }), x = Ze({
    hour: "numeric",
    hour12: !0
  }), E = S(() => {
    let p = /* @__PURE__ */ new Date();
    return p.setHours(0), x.formatToParts(p).find((M) => M.type === "dayPeriod").value;
  }, [
    x
  ]), F = S(() => {
    let p = /* @__PURE__ */ new Date();
    return p.setHours(12), x.formatToParts(p).find((M) => M.type === "dayPeriod").value;
  }, [
    x
  ]), _ = Ze({
    year: "numeric",
    era: "narrow",
    timeZone: "UTC"
  }), B = S(() => {
    if (e.type !== "era") return [];
    let p = U(new N(1, 1, 1), t.calendar), M = t.calendar.getEras().map((P) => {
      let X = p.set({
        year: 1,
        month: 1,
        day: 1,
        era: P
      }).toDate("UTC"), Oe = _.formatToParts(X).find((je) => je.type === "era").value;
      return {
        era: P,
        formatted: Oe
      };
    }), k = pl(M.map((P) => P.formatted));
    if (k) for (let P of M) P.formatted = P.formatted.slice(k);
    return M;
  }, [
    _,
    t.calendar,
    e.type
  ]), I = (p) => {
    if (t.isDisabled || t.isReadOnly) return;
    let M = r.current + p;
    switch (e.type) {
      case "dayPeriod":
        if (g(E, p)) t.setSegment("dayPeriod", 0);
        else if (g(F, p)) t.setSegment("dayPeriod", 12);
        else break;
        s.focusNext();
        break;
      case "era": {
        let k = B.find((P) => g(P.formatted, p));
        k && (t.setSegment("era", k.era), s.focusNext());
        break;
      }
      case "day":
      case "hour":
      case "minute":
      case "second":
      case "month":
      case "year": {
        if (!y.isValidPartialNumber(M)) return;
        let k = y.parse(M), P = k, X = e.minValue === 0;
        if (e.type === "hour" && t.dateFormatter.resolvedOptions().hour12) {
          switch (t.dateFormatter.resolvedOptions().hourCycle) {
            case "h11":
              k > 11 && (P = y.parse(p));
              break;
            case "h12":
              X = !1, k > 12 && (P = y.parse(p));
              break;
          }
          e.value >= 12 && k > 1 && (k += 12);
        } else k > e.maxValue && (P = y.parse(p));
        if (isNaN(k)) return;
        let ee = P !== 0 || X;
        ee && t.setSegment(e.type, P), +(k + "0") > e.maxValue || M.length >= String(e.maxValue).length ? (r.current = "", ee && s.focusNext()) : r.current = M;
        break;
      }
    }
  }, R = () => {
    r.current = "", Po(a.current, {
      containingElement: Bo(a.current)
    }), window.getSelection().collapse(a.current);
  }, m = J("");
  va(a, "beforeinput", (p) => {
    switch (p.preventDefault(), p.inputType) {
      case "deleteContentBackward":
      case "deleteContentForward":
        y.isValidPartialNumber(e.text) && !t.isReadOnly && b();
        break;
      case "insertCompositionText":
        m.current = a.current.textContent, a.current.textContent = a.current.textContent;
        break;
      default:
        p.data != null && I(p.data);
        break;
    }
  }), va(a, "input", (p) => {
    let { inputType: M, data: k } = p;
    switch (M) {
      case "insertCompositionText":
        a.current.textContent = m.current, (g(E, k) || g(F, k)) && I(k);
        break;
    }
  }), Oa(() => {
    let p = a.current;
    return () => {
      document.activeElement === p && (s.focusPrevious() || s.focusNext());
    };
  }, [
    a,
    s
  ]);
  let h = ai() || e.type === "timeZoneName" ? {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuetext": null,
    "aria-valuenow": null
  } : {}, v = S(() => t.segments.find((p) => p.isEditable), [
    t.segments
  ]);
  e !== v && !t.isInvalid && (l = void 0);
  let L = ui(), V = !t.isDisabled && !t.isReadOnly && e.isEditable, Y = e.type === "literal" ? "" : u.of(e.type), T = Yu({
    "aria-label": `${Y}${i ? `, ${i}` : ""}${o ? ", " : ""}`,
    "aria-labelledby": o
  });
  return e.type === "literal" ? {
    segmentProps: {
      "aria-hidden": !0
    }
  } : {
    segmentProps: j(w, T, {
      id: L,
      ...h,
      "aria-invalid": t.isInvalid ? "true" : void 0,
      "aria-describedby": l,
      "aria-readonly": t.isReadOnly || !e.isEditable ? "true" : void 0,
      "data-placeholder": e.isPlaceholder || void 0,
      contentEditable: V,
      suppressContentEditableWarning: V,
      spellCheck: V ? "false" : void 0,
      autoCapitalize: V ? "off" : void 0,
      autoCorrect: V ? "off" : void 0,
      // Capitalization was changed in React 17...
      [parseInt(d.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: V ? "next" : void 0,
      inputMode: t.isDisabled || e.type === "dayPeriod" || e.type === "era" || !V ? void 0 : "numeric",
      tabIndex: t.isDisabled ? void 0 : 0,
      onKeyDown: A,
      onFocus: R,
      style: {
        caretColor: "transparent"
      },
      // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
      onPointerDown(p) {
        p.stopPropagation();
      },
      onMouseDown(p) {
        p.stopPropagation();
      }
    })
  };
}
function pl(e) {
  e.sort();
  let t = e[0], a = e[e.length - 1];
  for (let r = 0; r < t.length; r++)
    if (t[r] !== a[r]) return r;
  return 0;
}
var Vn = {};
Vn = {
  rangeOverflow: (e) => `يجب أن تكون القيمة ${e.maxValue} أو قبل ذلك.`,
  rangeReversed: "تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء.",
  rangeUnderflow: (e) => `يجب أن تكون القيمة ${e.minValue} أو بعد ذلك.`,
  unavailableDate: "البيانات المحددة غير متاحة."
};
var Tn = {};
Tn = {
  rangeOverflow: (e) => `Стойността трябва да е ${e.maxValue} или по-ранна.`,
  rangeReversed: "Началната дата трябва да е преди крайната.",
  rangeUnderflow: (e) => `Стойността трябва да е ${e.minValue} или по-късно.`,
  unavailableDate: "Избраната дата не е налична."
};
var Nn = {};
Nn = {
  rangeOverflow: (e) => `Hodnota musí být ${e.maxValue} nebo dřívější.`,
  rangeReversed: "Datum zahájení musí předcházet datu ukončení.",
  rangeUnderflow: (e) => `Hodnota musí být ${e.minValue} nebo pozdější.`,
  unavailableDate: "Vybrané datum není k dispozici."
};
var Ln = {};
Ln = {
  rangeOverflow: (e) => `Værdien skal være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen skal være før slutdatoen.",
  rangeUnderflow: (e) => `Værdien skal være ${e.minValue} eller nyere.`,
  unavailableDate: "Den valgte dato er ikke tilgængelig."
};
var On = {};
On = {
  rangeOverflow: (e) => `Der Wert muss ${e.maxValue} oder früher sein.`,
  rangeReversed: "Das Anfangsdatum muss vor dem Enddatum liegen.",
  rangeUnderflow: (e) => `Der Wert muss ${e.minValue} oder später sein.`,
  unavailableDate: "Das ausgewählte Datum ist nicht verfügbar."
};
var jn = {};
jn = {
  rangeOverflow: (e) => `Η τιμή πρέπει να είναι ${e.maxValue} ή παλαιότερη.`,
  rangeReversed: "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
  rangeUnderflow: (e) => `Η τιμή πρέπει να είναι ${e.minValue} ή μεταγενέστερη.`,
  unavailableDate: "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
};
var Un = {};
Un = {
  rangeUnderflow: (e) => `Value must be ${e.minValue} or later.`,
  rangeOverflow: (e) => `Value must be ${e.maxValue} or earlier.`,
  rangeReversed: "Start date must be before end date.",
  unavailableDate: "Selected date unavailable."
};
var zn = {};
zn = {
  rangeOverflow: (e) => `El valor debe ser ${e.maxValue} o anterior.`,
  rangeReversed: "La fecha de inicio debe ser anterior a la fecha de finalización.",
  rangeUnderflow: (e) => `El valor debe ser ${e.minValue} o posterior.`,
  unavailableDate: "Fecha seleccionada no disponible."
};
var Zn = {};
Zn = {
  rangeOverflow: (e) => `Väärtus peab olema ${e.maxValue} või varasem.`,
  rangeReversed: "Alguskuupäev peab olema enne lõppkuupäeva.",
  rangeUnderflow: (e) => `Väärtus peab olema ${e.minValue} või hilisem.`,
  unavailableDate: "Valitud kuupäev pole saadaval."
};
var Kn = {};
Kn = {
  rangeOverflow: (e) => `Arvon on oltava ${e.maxValue} tai sitä aikaisempi.`,
  rangeReversed: "Aloituspäivän on oltava ennen lopetuspäivää.",
  rangeUnderflow: (e) => `Arvon on oltava ${e.minValue} tai sitä myöhäisempi.`,
  unavailableDate: "Valittu päivämäärä ei ole käytettävissä."
};
var Yn = {};
Yn = {
  rangeOverflow: (e) => `La valeur doit être ${e.maxValue} ou antérieure.`,
  rangeReversed: "La date de début doit être antérieure à la date de fin.",
  rangeUnderflow: (e) => `La valeur doit être ${e.minValue} ou ultérieure.`,
  unavailableDate: "La date sélectionnée n’est pas disponible."
};
var Wn = {};
Wn = {
  rangeOverflow: (e) => `הערך חייב להיות ${e.maxValue} או מוקדם יותר.`,
  rangeReversed: "תאריך ההתחלה חייב להיות לפני תאריך הסיום.",
  rangeUnderflow: (e) => `הערך חייב להיות ${e.minValue} או מאוחר יותר.`,
  unavailableDate: "התאריך הנבחר אינו זמין."
};
var qn = {};
qn = {
  rangeOverflow: (e) => `Vrijednost mora biti ${e.maxValue} ili ranije.`,
  rangeReversed: "Datum početka mora biti prije datuma završetka.",
  rangeUnderflow: (e) => `Vrijednost mora biti ${e.minValue} ili kasnije.`,
  unavailableDate: "Odabrani datum nije dostupan."
};
var Jn = {};
Jn = {
  rangeOverflow: (e) => `Az értéknek ${e.maxValue} vagy korábbinak kell lennie.`,
  rangeReversed: "A kezdő dátumnak a befejező dátumnál korábbinak kell lennie.",
  rangeUnderflow: (e) => `Az értéknek ${e.minValue} vagy későbbinek kell lennie.`,
  unavailableDate: "A kiválasztott dátum nem érhető el."
};
var Hn = {};
Hn = {
  rangeOverflow: (e) => `Il valore deve essere ${e.maxValue} o precedente.`,
  rangeReversed: "La data di inizio deve essere antecedente alla data di fine.",
  rangeUnderflow: (e) => `Il valore deve essere ${e.minValue} o successivo.`,
  unavailableDate: "Data selezionata non disponibile."
};
var Gn = {};
Gn = {
  rangeOverflow: (e) => `値は ${e.maxValue} 以下にする必要があります。`,
  rangeReversed: "開始日は終了日より前にする必要があります。",
  rangeUnderflow: (e) => `値は ${e.minValue} 以上にする必要があります。`,
  unavailableDate: "選択した日付は使用できません。"
};
var Qn = {};
Qn = {
  rangeOverflow: (e) => `값은 ${e.maxValue} 이전이어야 합니다.`,
  rangeReversed: "시작일은 종료일 이전이어야 합니다.",
  rangeUnderflow: (e) => `값은 ${e.minValue} 이상이어야 합니다.`,
  unavailableDate: "선택한 날짜를 사용할 수 없습니다."
};
var Xn = {};
Xn = {
  rangeOverflow: (e) => `Reikšmė turi būti ${e.maxValue} arba ankstesnė.`,
  rangeReversed: "Pradžios data turi būti ankstesnė nei pabaigos data.",
  rangeUnderflow: (e) => `Reikšmė turi būti ${e.minValue} arba naujesnė.`,
  unavailableDate: "Pasirinkta data nepasiekiama."
};
var eu = {};
eu = {
  rangeOverflow: (e) => `Vērtībai ir jābūt ${e.maxValue} vai agrākai.`,
  rangeReversed: "Sākuma datumam ir jābūt pirms beigu datuma.",
  rangeUnderflow: (e) => `Vērtībai ir jābūt ${e.minValue} vai vēlākai.`,
  unavailableDate: "Atlasītais datums nav pieejams."
};
var tu = {};
tu = {
  rangeOverflow: (e) => `Verdien må være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen må være før sluttdatoen.",
  rangeUnderflow: (e) => `Verdien må være ${e.minValue} eller senere.`,
  unavailableDate: "Valgt dato utilgjengelig."
};
var au = {};
au = {
  rangeOverflow: (e) => `Waarde moet ${e.maxValue} of eerder zijn.`,
  rangeReversed: "De startdatum moet voor de einddatum liggen.",
  rangeUnderflow: (e) => `Waarde moet ${e.minValue} of later zijn.`,
  unavailableDate: "Geselecteerde datum niet beschikbaar."
};
var ru = {};
ru = {
  rangeOverflow: (e) => `Wartość musi mieć wartość ${e.maxValue} lub wcześniejszą.`,
  rangeReversed: "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
  rangeUnderflow: (e) => `Wartość musi mieć wartość ${e.minValue} lub późniejszą.`,
  unavailableDate: "Wybrana data jest niedostępna."
};
var nu = {};
nu = {
  rangeOverflow: (e) => `O valor deve ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data inicial deve ser anterior à data final.",
  rangeUnderflow: (e) => `O valor deve ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var uu = {};
uu = {
  rangeOverflow: (e) => `O valor tem de ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data de início deve ser anterior à data de fim.",
  rangeUnderflow: (e) => `O valor tem de ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var iu = {};
iu = {
  rangeOverflow: (e) => `Valoarea trebuie să fie ${e.maxValue} sau anterioară.`,
  rangeReversed: "Data de început trebuie să fie anterioară datei de sfârșit.",
  rangeUnderflow: (e) => `Valoarea trebuie să fie ${e.minValue} sau ulterioară.`,
  unavailableDate: "Data selectată nu este disponibilă."
};
var ou = {};
ou = {
  rangeOverflow: (e) => `Значение должно быть не позже ${e.maxValue}.`,
  rangeReversed: "Дата начала должна предшествовать дате окончания.",
  rangeUnderflow: (e) => `Значение должно быть не раньше ${e.minValue}.`,
  unavailableDate: "Выбранная дата недоступна."
};
var lu = {};
lu = {
  rangeOverflow: (e) => `Hodnota musí byť ${e.maxValue} alebo skoršia.`,
  rangeReversed: "Dátum začiatku musí byť skorší ako dátum konca.",
  rangeUnderflow: (e) => `Hodnota musí byť ${e.minValue} alebo neskoršia.`,
  unavailableDate: "Vybratý dátum je nedostupný."
};
var su = {};
su = {
  rangeOverflow: (e) => `Vrednost mora biti ${e.maxValue} ali starejša.`,
  rangeReversed: "Začetni datum mora biti pred končnim datumom.",
  rangeUnderflow: (e) => `Vrednost mora biti ${e.minValue} ali novejša.`,
  unavailableDate: "Izbrani datum ni na voljo."
};
var du = {};
du = {
  rangeOverflow: (e) => `Vrednost mora da bude ${e.maxValue} ili starija.`,
  rangeReversed: "Datum početka mora biti pre datuma završetka.",
  rangeUnderflow: (e) => `Vrednost mora da bude ${e.minValue} ili novija.`,
  unavailableDate: "Izabrani datum nije dostupan."
};
var cu = {};
cu = {
  rangeOverflow: (e) => `Värdet måste vara ${e.maxValue} eller tidigare.`,
  rangeReversed: "Startdatumet måste vara före slutdatumet.",
  rangeUnderflow: (e) => `Värdet måste vara ${e.minValue} eller senare.`,
  unavailableDate: "Det valda datumet är inte tillgängligt."
};
var fu = {};
fu = {
  rangeOverflow: (e) => `Değer, ${e.maxValue} veya öncesi olmalıdır.`,
  rangeReversed: "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
  rangeUnderflow: (e) => `Değer, ${e.minValue} veya sonrası olmalıdır.`,
  unavailableDate: "Seçilen tarih kullanılamıyor."
};
var mu = {};
mu = {
  rangeOverflow: (e) => `Значення має бути не пізніше ${e.maxValue}.`,
  rangeReversed: "Дата початку має передувати даті завершення.",
  rangeUnderflow: (e) => `Значення має бути не раніше ${e.minValue}.`,
  unavailableDate: "Вибрана дата недоступна."
};
var hu = {};
hu = {
  rangeOverflow: (e) => `值必须是 ${e.maxValue} 或更早日期。`,
  rangeReversed: "开始日期必须早于结束日期。",
  rangeUnderflow: (e) => `值必须是 ${e.minValue} 或更晚日期。`,
  unavailableDate: "所选日期不可用。"
};
var $u = {};
$u = {
  rangeOverflow: (e) => `值必須是 ${e.maxValue} 或更早。`,
  rangeReversed: "開始日期必須在結束日期之前。",
  rangeUnderflow: (e) => `值必須是 ${e.minValue} 或更晚。`,
  unavailableDate: "所選日期無法使用。"
};
var yu = {};
yu = {
  "ar-AE": Vn,
  "bg-BG": Tn,
  "cs-CZ": Nn,
  "da-DK": Ln,
  "de-DE": On,
  "el-GR": jn,
  "en-US": Un,
  "es-ES": zn,
  "et-EE": Zn,
  "fi-FI": Kn,
  "fr-FR": Yn,
  "he-IL": Wn,
  "hr-HR": qn,
  "hu-HU": Jn,
  "it-IT": Hn,
  "ja-JP": Gn,
  "ko-KR": Qn,
  "lt-LT": Xn,
  "lv-LV": eu,
  "nb-NO": tu,
  "nl-NL": au,
  "pl-PL": ru,
  "pt-BR": nu,
  "pt-PT": uu,
  "ro-RO": iu,
  "ru-RU": ou,
  "sk-SK": lu,
  "sl-SI": su,
  "sr-SP": du,
  "sv-SE": cu,
  "tr-TR": fu,
  "uk-UA": mu,
  "zh-CN": hu,
  "zh-TW": $u
};
function Dl(e) {
  return e && e.__esModule ? e.default : e;
}
const vl = new jt(Dl(yu));
function gl() {
  return typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
}
function xl(e, t, a, r, n) {
  let u = e != null && a != null && e.compare(a) > 0, i = e != null && t != null && e.compare(t) < 0, o = e != null && (r == null ? void 0 : r(e)) || !1, l = u || i || o, s = [];
  if (l) {
    let f = gl(), c = jt.getGlobalDictionaryForPackage("@react-stately/datepicker") || vl, $ = new ni(f, c), C = new Re(f, Vt({}, n)), w = C.resolvedOptions().timeZone;
    i && s.push($.format("rangeUnderflow", {
      minValue: C.format(t.toDate(w))
    })), u && s.push($.format("rangeOverflow", {
      maxValue: C.format(a.toDate(w))
    })), o && s.push($.format("unavailableDate"));
  }
  return {
    isInvalid: l,
    validationErrors: s,
    validationDetails: {
      badInput: o,
      customError: !1,
      patternMismatch: !1,
      rangeOverflow: u,
      rangeUnderflow: i,
      stepMismatch: !1,
      tooLong: !1,
      tooShort: !1,
      typeMismatch: !1,
      valueMissing: !1,
      valid: !l
    }
  };
}
const El = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit"
}, Cl = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
};
function Vt(e, t) {
  e = {
    ...t.shouldForceLeadingZeros ? Cl : El,
    ...e
  };
  let r = t.granularity || "minute", n = Object.keys(e);
  var u;
  let i = n.indexOf((u = t.maxGranularity) !== null && u !== void 0 ? u : "year");
  i < 0 && (i = 0);
  let o = n.indexOf(r);
  if (o < 0 && (o = 2), i > o) throw new Error("maxGranularity must be greater than granularity");
  let l = n.slice(i, o + 1).reduce((f, c) => (f[c] = e[c], f), {});
  return t.hourCycle != null && (l.hour12 = t.hourCycle === 12), l.timeZone = t.timeZone || "UTC", (r === "hour" || r === "minute" || r === "second") && t.timeZone && !t.hideTimeZone && (l.timeZoneName = "short"), t.showEra && i === 0 && (l.era = "short"), l;
}
function bu(e, t) {
  if (e === null) return null;
  if (e)
    return U(e, t);
}
function ke(e, t, a, r) {
  if (e) return bu(e, a);
  let n = U(Ii(r).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }), a);
  return t === "year" || t === "month" || t === "day" ? Ni(n) : r ? n : ye(n);
}
function wl(e, t) {
  let a = e && "timeZone" in e ? e.timeZone : void 0, r = e && "minute" in e ? "minute" : "day";
  if (e && t && !(t in e)) throw new Error("Invalid granularity " + t + " for value " + e.toString());
  let [n, u] = W([
    r,
    a
  ]);
  e && (n[0] !== r || n[1] !== a) && u([
    r,
    a
  ]), t || (t = e ? r : n[0]);
  let i = e ? a : n[1];
  return [
    t,
    i
  ];
}
const Bl = new jt({
  ach: {
    year: "mwaka",
    month: "dwe",
    day: "nino"
  },
  af: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  am: {
    year: "ዓዓዓዓ",
    month: "ሚሜ",
    day: "ቀቀ"
  },
  an: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ar: {
    year: "سنة",
    month: "شهر",
    day: "يوم"
  },
  ast: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  az: {
    year: "iiii",
    month: "aa",
    day: "gg"
  },
  be: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bg: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bn: {
    year: "yyyy",
    month: "মিমি",
    day: "dd"
  },
  br: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  bs: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  ca: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  cak: {
    year: "jjjj",
    month: "ii",
    day: "q'q'"
  },
  ckb: {
    year: "ساڵ",
    month: "مانگ",
    day: "ڕۆژ"
  },
  cs: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  cy: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  da: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  de: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  dsb: {
    year: "llll",
    month: "mm",
    day: "źź"
  },
  el: {
    year: "εεεε",
    month: "μμ",
    day: "ηη"
  },
  en: {
    year: "yyyy",
    month: "mm",
    day: "dd"
  },
  eo: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  es: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  et: {
    year: "aaaa",
    month: "kk",
    day: "pp"
  },
  eu: {
    year: "uuuu",
    month: "hh",
    day: "ee"
  },
  fa: {
    year: "سال",
    month: "ماه",
    day: "روز"
  },
  ff: {
    year: "hhhh",
    month: "ll",
    day: "ññ"
  },
  fi: {
    year: "vvvv",
    month: "kk",
    day: "pp"
  },
  fr: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  fy: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  ga: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gd: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gl: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  he: {
    year: "שנה",
    month: "חודש",
    day: "יום"
  },
  hr: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  hsb: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  hu: {
    year: "éééé",
    month: "hh",
    day: "nn"
  },
  ia: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  id: {
    year: "tttt",
    month: "bb",
    day: "hh"
  },
  it: {
    year: "aaaa",
    month: "mm",
    day: "gg"
  },
  ja: {
    year: " 年 ",
    month: "月",
    day: "日"
  },
  ka: {
    year: "წწწწ",
    month: "თთ",
    day: "რრ"
  },
  kk: {
    year: "жжжж",
    month: "аа",
    day: "кк"
  },
  kn: {
    year: "ವವವವ",
    month: "ಮಿಮೀ",
    day: "ದಿದಿ"
  },
  ko: {
    year: "연도",
    month: "월",
    day: "일"
  },
  lb: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  lo: {
    year: "ປປປປ",
    month: "ດດ",
    day: "ວວ"
  },
  lt: {
    year: "mmmm",
    month: "mm",
    day: "dd"
  },
  lv: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  meh: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ml: {
    year: "വർഷം",
    month: "മാസം",
    day: "തീയതി"
  },
  ms: {
    year: "tttt",
    month: "mm",
    day: "hh"
  },
  nl: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  nn: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  no: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  oc: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  pl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  pt: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  rm: {
    year: "oooo",
    month: "mm",
    day: "dd"
  },
  ro: {
    year: "aaaa",
    month: "ll",
    day: "zz"
  },
  ru: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  sc: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  scn: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  sk: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  sl: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  sr: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  sv: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  szl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  tg: {
    year: "сссс",
    month: "мм",
    day: "рр"
  },
  th: {
    year: "ปปปป",
    month: "ดด",
    day: "วว"
  },
  tr: {
    year: "yyyy",
    month: "aa",
    day: "gg"
  },
  uk: {
    year: "рррр",
    month: "мм",
    day: "дд"
  },
  "zh-CN": {
    year: "年",
    month: "月",
    day: "日"
  },
  "zh-TW": {
    year: "年",
    month: "月",
    day: "日"
  }
}, "en");
function Al(e, t, a) {
  return e === "era" || e === "dayPeriod" ? t : e === "year" || e === "month" || e === "day" ? Bl.getStringForLocale(e, a) : "––";
}
const Ye = {
  year: !0,
  month: !0,
  day: !0,
  hour: !0,
  minute: !0,
  second: !0,
  dayPeriod: !0,
  era: !0
}, ka = {
  year: 5,
  month: 2,
  day: 7,
  hour: 2,
  minute: 15,
  second: 15
}, Fl = {
  dayperiod: "dayPeriod"
};
function Pl(e) {
  let { locale: t, createCalendar: a, hideTimeZone: r, isDisabled: n, isReadOnly: u, isRequired: i, minValue: o, maxValue: l, isDateUnavailable: s } = e, f = e.value || e.defaultValue || e.placeholderValue, [c, $] = wl(f, e.granularity), C = $ || "UTC";
  if (f && !(c in f)) throw new Error("Invalid granularity " + c + " for value " + f.toString());
  let w = S(() => new Re(t), [
    t
  ]), y = S(() => a(w.resolvedOptions().calendar), [
    a,
    w
  ]), [b, A] = Wu(e.value, e.defaultValue, e.onChange), g = S(() => bu(b, y), [
    b,
    y
  ]), [x, E] = W(() => ke(e.placeholderValue, c, y, $)), F = g || x, _ = y.identifier === "gregory" && F.era === "BC", B = S(() => {
    var D;
    return {
      granularity: c,
      maxGranularity: (D = e.maxGranularity) !== null && D !== void 0 ? D : "year",
      timeZone: $,
      hideTimeZone: r,
      hourCycle: e.hourCycle,
      showEra: _,
      shouldForceLeadingZeros: e.shouldForceLeadingZeros
    };
  }, [
    e.maxGranularity,
    c,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    $,
    r,
    _
  ]), I = S(() => Vt({}, B), [
    B
  ]), R = S(() => new Re(t, I), [
    t,
    I
  ]), m = S(() => R.resolvedOptions(), [
    R
  ]), h = S(() => R.formatToParts(/* @__PURE__ */ new Date()).filter((D) => Ye[D.type]).reduce((D, O) => (D[O.type] = !0, D), {}), [
    R
  ]), [v, L] = W(() => e.value || e.defaultValue ? {
    ...h
  } : {}), V = J(), Y = J(y.identifier);
  q(() => {
    y.identifier !== Y.current && (Y.current = y.identifier, E((D) => Object.keys(v).length > 0 ? U(D, y) : ke(e.placeholderValue, c, y, $)));
  }, [
    y,
    c,
    v,
    $,
    e.placeholderValue
  ]), b && Object.keys(v).length < Object.keys(h).length && (v = {
    ...h
  }, L(v)), b == null && Object.keys(v).length === Object.keys(h).length && (v = {}, L(v), E(ke(e.placeholderValue, c, y, $)));
  let T = g && Object.keys(v).length >= Object.keys(h).length ? g : x, p = (D) => {
    if (e.isDisabled || e.isReadOnly) return;
    let O = Object.keys(v), z = Object.keys(h);
    D == null ? (A(null), E(ke(e.placeholderValue, c, y, $)), L({})) : O.length >= z.length || O.length === z.length - 1 && h.dayPeriod && !v.dayPeriod && V.current !== "dayPeriod" ? (D = U(D, (f == null ? void 0 : f.calendar) || new Q()), A(D)) : E(D), V.current = null;
  }, M = S(() => T.toDate(C), [
    T,
    C
  ]), k = S(() => R.formatToParts(M).map((D) => {
    let O = Ye[D.type];
    D.type === "era" && y.getEras().length === 1 && (O = !1);
    let z = Ye[D.type] && !v[D.type], le = Ye[D.type] ? Al(D.type, D.value, t) : null;
    return {
      type: Fl[D.type] || D.type,
      text: z ? le : D.value,
      ...kl(T, D.type, m),
      isPlaceholder: z,
      placeholder: le,
      isEditable: O
    };
  }), [
    M,
    v,
    R,
    m,
    T,
    y,
    t
  ]);
  h.era && v.year && !v.era ? (v.era = !0, L({
    ...v
  })) : !h.era && v.era && (delete v.era, L({
    ...v
  }));
  let P = (D) => {
    v[D] = !0, D === "year" && h.era && (v.era = !0), L({
      ...v
    });
  }, X = (D, O) => {
    if (v[D])
      p(_l(T, D, O, m));
    else {
      P(D);
      let z = Object.keys(v), le = Object.keys(h);
      (z.length >= le.length || z.length === le.length - 1 && h.dayPeriod && !v.dayPeriod) && p(T);
    }
  }, ee = S(() => xl(b, o, l, s, B), [
    b,
    o,
    l,
    s,
    B
  ]), Oe = ul({
    ...e,
    value: b,
    builtinValidation: ee
  }), je = Oe.displayValidation.isInvalid, vu = e.validationState || (je ? "invalid" : null);
  var st;
  return {
    ...Oe,
    value: g,
    dateValue: M,
    calendar: y,
    setValue: p,
    segments: k,
    dateFormatter: R,
    validationState: vu,
    isInvalid: je,
    granularity: c,
    maxGranularity: (st = e.maxGranularity) !== null && st !== void 0 ? st : "year",
    isDisabled: n,
    isReadOnly: u,
    isRequired: i,
    increment(D) {
      X(D, 1);
    },
    decrement(D) {
      X(D, -1);
    },
    incrementPage(D) {
      X(D, ka[D] || 1);
    },
    decrementPage(D) {
      X(D, -(ka[D] || 1));
    },
    setSegment(D, O) {
      P(D), p(Il(T, D, O, m));
    },
    confirmPlaceholder() {
      if (e.isDisabled || e.isReadOnly) return;
      let D = Object.keys(v), O = Object.keys(h);
      D.length === O.length - 1 && h.dayPeriod && !v.dayPeriod && (v = {
        ...h
      }, L(v), p(T.copy()));
    },
    clearSegment(D) {
      delete v[D], V.current = D, L({
        ...v
      });
      let O = ke(e.placeholderValue, c, y, $), z = T;
      if (D === "dayPeriod" && "hour" in T && "hour" in O) {
        let le = T.hour >= 12, Gt = O.hour >= 12;
        le && !Gt ? z = T.set({
          hour: T.hour - 12
        }) : !le && Gt && (z = T.set({
          hour: T.hour + 12
        }));
      } else D in T && (z = T.set({
        [D]: O[D]
      }));
      A(null), p(z);
    },
    formatValue(D) {
      if (!g) return "";
      let O = Vt(D, B);
      return new Re(t, O).format(M);
    }
  };
}
function kl(e, t, a) {
  switch (t) {
    case "era": {
      let r = e.calendar.getEras();
      return {
        value: r.indexOf(e.era),
        minValue: 0,
        maxValue: r.length - 1
      };
    }
    case "year":
      return {
        value: e.year,
        minValue: 1,
        maxValue: e.calendar.getYearsInEra(e)
      };
    case "month":
      return {
        value: e.month,
        minValue: Si(e),
        maxValue: e.calendar.getMonthsInYear(e)
      };
    case "day":
      return {
        value: e.day,
        minValue: Ri(e),
        maxValue: e.calendar.getDaysInMonth(e)
      };
  }
  if ("hour" in e) switch (t) {
    case "dayPeriod":
      return {
        value: e.hour >= 12 ? 12 : 0,
        minValue: 0,
        maxValue: 12
      };
    case "hour":
      if (a.hour12) {
        let r = e.hour >= 12;
        return {
          value: e.hour,
          minValue: r ? 12 : 0,
          maxValue: r ? 23 : 11
        };
      }
      return {
        value: e.hour,
        minValue: 0,
        maxValue: 23
      };
    case "minute":
      return {
        value: e.minute,
        minValue: 0,
        maxValue: 59
      };
    case "second":
      return {
        value: e.second,
        minValue: 0,
        maxValue: 59
      };
  }
  return {};
}
function _l(e, t, a, r) {
  switch (t) {
    case "era":
    case "year":
    case "month":
    case "day":
      return e.cycle(t, a, {
        round: t === "year"
      });
  }
  if ("hour" in e) switch (t) {
    case "dayPeriod": {
      let n = e.hour, u = n >= 12;
      return e.set({
        hour: u ? n - 12 : n + 12
      });
    }
    case "hour":
    case "minute":
    case "second":
      return e.cycle(t, a, {
        round: t !== "hour",
        hourCycle: r.hour12 ? 12 : 24
      });
  }
}
function Il(e, t, a, r) {
  switch (t) {
    case "day":
    case "month":
    case "year":
    case "era":
      return e.set({
        [t]: a
      });
  }
  if ("hour" in e) switch (t) {
    case "dayPeriod": {
      let n = e.hour, u = n >= 12;
      return a >= 12 === u ? e : e.set({
        hour: u ? n - 12 : n + 12
      });
    }
    case "hour":
      if (r.hour12) {
        let u = e.hour >= 12;
        !u && a === 12 && (a = 0), u && a < 12 && (a += 12);
      }
    case "minute":
    case "second":
      return e.set({
        [t]: a
      });
  }
}
const Ml = "_dateField_1mjb8_10", Sl = "_inputWrapper_1mjb8_17", Rl = "_dateInput_1mjb8_27", Vl = "_small_1mjb8_47", Tl = "_withLeftIcon_1mjb8_56", Nl = "_dateSegment_1mjb8_92", Ll = "_day_1mjb8_114", Ol = "_month_1mjb8_115", jl = "_year_1mjb8_120", Ul = "_dateSegmentsContainer_1mjb8_125", zl = "_icon_1mjb8_130", ae = {
  dateField: Ml,
  inputWrapper: Sl,
  dateInput: Rl,
  small: Vl,
  withLeftIcon: Tl,
  dateSegment: Nl,
  day: Ll,
  month: Ol,
  year: jl,
  dateSegmentsContainer: Ul,
  icon: zl
}, _a = ["-", ".", "/", "\\", ","];
function Zl(e, t) {
  let a;
  e === "Backspace" ? a = {
    inputType: "deleteContentBackward"
  } : a = {
    inputType: "insertText",
    data: e
  }, t.focus();
  const r = new InputEvent("beforeinput", a);
  t.dispatchEvent(r);
}
function Ia(e, t) {
  if (t === "month" && /\d{2}-\d{4}/.test(e)) {
    const a = e.split("-");
    return ua(`${a[1]}-${a[0]}-01`);
  }
  return ua(e);
}
const fd = ({
  value: e,
  defaultValue: t,
  label: a,
  helpText: r,
  size: n = "large",
  labelTextSize: u = n,
  error: i,
  ...o
}) => {
  const l = (m) => {
    m.getAttribute("aria-valuetext") === "Empty" ? m.dataset.wasEmpty = "true" : delete m.dataset.wasEmpty;
  }, s = (m) => {
    var v, L, V;
    const h = m.target;
    if (!m.key.match(/^[0-9]+$/) && !_a.includes(m.key))
      return !0;
    if (
      // Typing more than 4 characters for year, ignore
      m.key.match(/^[0-9]$/) && h.dataset.type === "year" && ((v = h.getAttribute("aria-valuetext")) != null && v.match(/^[0-9]{4}$/))
    )
      return m.preventDefault(), m.stopPropagation(), !1;
    // Typing a separator key in a field with a focusable sibling
    _a.includes(m.key) && ((V = (L = h.nextElementSibling) == null ? void 0 : L.nextElementSibling) != null && V.hasAttribute("tabindex")) && h.nextElementSibling.nextElementSibling.focus();
  }, f = (m) => {
    var v, L;
    const h = m.target;
    if (m.key === "Backspace" && // Skipping slashes, do we have a previous focusable element
    ((L = (v = h.previousElementSibling) == null ? void 0 : v.previousElementSibling) != null && L.hasAttribute(
      "tabindex"
    )) && h.dataset.wasEmpty) {
      const V = h.previousElementSibling.previousElementSibling;
      Zl(m.key, V);
    }
    l(h);
  }, c = (m) => {
    if (o.onChange)
      if (o.granularity === "month")
        if (m) {
          const h = `${m.month}`.padStart(2, "0");
          o.onChange(`${h}-${m.year}`);
        } else
          o.onChange("");
      else
        o.onChange(m);
  }, $ = (m) => {
    const h = m.target;
    l(h);
  }, C = typeof e == "string" ? Ia(e, o.granularity || "day") : e, w = typeof t == "string" ? Ia(t, o.granularity || "day") : t, y = K(
    o,
    ae.dateField,
    oe(n, ae)
  ), b = {
    ...o,
    granularity: o.granularity === "month" ? "day" : o.granularity,
    defaultValue: w,
    value: C,
    onChange: c,
    onKeyDown: s,
    onKeyUp: f,
    onFocus: $
  };
  let { locale: A } = Ne(), g = Pl({
    ...b,
    locale: A,
    createCalendar: go
  }), x = d.useRef(null), {
    labelProps: E,
    fieldProps: F,
    inputProps: _,
    descriptionProps: B,
    errorMessageProps: I,
    ...R
  } = cl(b, g, x);
  return q(() => {
    !b.defaultValue && !b.value && o.granularity === "month" && g.setSegment("day", 1);
  }, []), /* @__PURE__ */ d.createElement(Va.Provider, { value: R }, /* @__PURE__ */ d.createElement("div", { className: y }, !!a && /* @__PURE__ */ d.createElement(De, { ...E, size: u }, a), !!r && /* @__PURE__ */ d.createElement(
    pe,
    {
      ...B,
      size: u,
      slot: "description"
    },
    r
  ), /* @__PURE__ */ d.createElement("div", { className: ae.inputWrapper }, /* @__PURE__ */ d.createElement("div", { className: ae.icon }, /* @__PURE__ */ d.createElement(H, { icon: "Calendar", size: ie(n) })), /* @__PURE__ */ d.createElement(
    Kl,
    {
      ...F,
      granularity: o.granularity,
      "data-invalid": o.isInvalid || void 0,
      "data-disabled": o.isDisabled || void 0,
      state: g,
      ref: x
    }
  )), /* @__PURE__ */ d.createElement(
    Be,
    {
      error: i,
      size: u,
      ...I
    }
  )));
}, Kl = d.forwardRef(
  ({
    granularity: e,
    state: t,
    ...a
  }, r) => {
    const n = (u) => {
      if (e === "month") {
        const i = u.findIndex((o) => o.type === "day");
        return [
          ...u.slice(0, i),
          ...u.slice(i + 2)
        ];
      }
      return u;
    };
    return a.className = K(
      a,
      ae.dateInput,
      ae.withLeftIcon
    ), /* @__PURE__ */ d.createElement("div", { ref: r, ...a }, n(t.segments).map((u, i) => {
      let o;
      switch (u.type) {
        case "day":
          o = ae.day;
          break;
        case "month":
          o = ae.month;
          break;
        case "year":
          o = ae.year;
          break;
      }
      return /* @__PURE__ */ d.createElement(
        Yl,
        {
          key: i,
          segment: u,
          state: t,
          className: fe(ae.dateSegment, o)
        }
      );
    }));
  }
);
function Yl({
  segment: e,
  state: t,
  className: a
}) {
  let r = d.useRef(null), { segmentProps: n } = bl(e, t, r);
  return /* @__PURE__ */ d.createElement(
    "div",
    {
      ...n,
      ref: r,
      className: fe(
        `segment ${e.isPlaceholder ? "placeholder" : ""}`,
        a
      )
    },
    e.text
  );
}
function Wl({
  files: e,
  isDropTarget: t,
  isInvalid: a
}) {
  return t || e != null && e.length ? "ImageCheck" : a ? "ExclamationCircle" : "ImagePlus";
}
function ql({
  errorMessage: e,
  files: t,
  isDropTarget: a,
  isInvalid: r
}) {
  return a ? "Yeah! Drop it!" : e ? Array.isArray(e) ? e.join(". ") : e : r ? "Invalid file" : (t == null ? void 0 : t.length) === 1 && "name" in t[0] ? t[0].name : (t == null ? void 0 : t.length) === 1 && t[0].kind === "text" ? "Text content" : t.length >= 2 ? `${t.length} files` : "Drag and drop or click to upload";
}
const Jl = (e) => {
  const { acceptDirectory: t, acceptedFileTypes: a, allowsMultiple: r, acceptText: n } = e.triggerProps;
  if (!r && e.items.length > 1)
    return "Invalid number of files (must be only one file)";
  const u = new Set(
    [...a || []].map((i) => i.toLowerCase())
  );
  for (const i of e.items) {
    if (i.kind === "directory" && !t)
      return "Invalid number of files (cannot be folder)";
    if (i.kind === "text" && !n)
      return "Invalid kind (file format required)";
    if (i.kind === "file" && a) {
      const o = i.type.toLowerCase(), l = i.name.includes(".") ? i.name.slice(i.name.lastIndexOf(".")).toLowerCase() : "";
      if (!u.has(o) && !u.has(l))
        return `Invalid file type (${a.join(", ")} required)`;
    }
  }
}, Hl = "_field_fbrdk_4", Gl = "_zone_fbrdk_10", Ql = "_button_fbrdk_47", Xl = "_large_fbrdk_63", es = "_icon_fbrdk_68", ts = "_content_fbrdk_72", as = "_clear_fbrdk_85", se = {
  field: Hl,
  zone: Gl,
  button: Ql,
  large: Xl,
  icon: es,
  content: ts,
  clear: as
}, rs = "application/octet-stream";
function md({
  acceptText: e,
  children: t = ql,
  buttonProps: a,
  error: r,
  label: n,
  labelTextSize: u,
  helpText: i,
  size: o = "large",
  icon: l = Wl,
  iconColor: s = "currentcolor",
  onChange: f,
  isInvalid: c,
  validate: $ = Jl,
  className: C,
  style: w,
  "aria-describedby": y,
  "aria-details": b,
  "aria-label": A,
  "aria-labelledby": g,
  slot: x,
  ...E
}) {
  const [F, _] = W(!1), [B, I] = W([]), [R, m] = W(
    r
  );
  q(() => {
    m(r);
  }, [r]);
  const h = async (k) => {
    if ($)
      try {
        const P = await $(k);
        if (P) {
          m(P), _(!0), I([]);
          return;
        }
      } catch (P) {
        console.error(P), _(!0), I([]);
        return;
      }
    m(), _(!1), I(k.items), f && f(k);
  }, v = (k) => {
    const P = {
      ...k,
      triggerProps: {
        ...E,
        acceptText: e
      }
    };
    h(P);
  }, L = (k) => {
    const P = [];
    for (const ee of k ?? [])
      P.push({
        kind: "file",
        type: ee.type || rs,
        name: ee.name,
        getText: () => ee.text(),
        getFile: () => Promise.resolve(ee)
      });
    const X = {
      type: "pick",
      items: P,
      triggerProps: {
        ...E,
        acceptText: e
      }
    };
    h(X);
  }, V = j(
    {
      className: C,
      style: w
    },
    { className: se.field }
  ), Y = j(
    {
      slot: x
    },
    {
      className: fe(se.zone, oe(o, se)),
      onDrop: v,
      "data-invalid": (c ?? F) || void 0,
      "data-empty": !B.length || void 0
    }
  ), T = j(E, {
    className: se.trigger,
    onSelect: L
  }), p = j(a, {
    "aria-describedby": y,
    "aria-details": b,
    "aria-label": A ?? n,
    "aria-labelledby": g,
    className: se.button
  }), M = (k) => {
    const P = {
      isInvalid: c ?? F,
      files: B,
      errorMessage: R,
      ...k
    };
    return /* @__PURE__ */ d.createElement(Fu, { ...T }, /* @__PURE__ */ d.createElement(it, { ...p }, l && /* @__PURE__ */ d.createElement(
      H,
      {
        icon: typeof l == "function" ? l(P) : l,
        color: s,
        size: "large",
        "aria-hidden": "true",
        className: se.icon
      }
    ), /* @__PURE__ */ d.createElement("span", { className: se.content }, typeof t == "function" ? t(P) : r ?? R ?? t), !!(B != null && B.length) && /* @__PURE__ */ d.createElement(
      H,
      {
        icon: "Ban",
        "aria-hidden": "true",
        size: "small",
        color: s,
        className: se.clear
      }
    )));
  };
  return /* @__PURE__ */ d.createElement("div", { ...V }, n && /* @__PURE__ */ d.createElement(De, { size: u ?? o }, n), i && /* @__PURE__ */ d.createElement(pe, { size: u ?? o }, i), /* @__PURE__ */ d.createElement(Au, { ...Y }, M));
}
const ns = "_tag_92x0l_4", us = "_icon_92x0l_23", is = "_label_92x0l_27", Ct = {
  tag: ns,
  icon: us,
  label: is
};
function os({
  item: e,
  ...t
}) {
  const { hoverProps: a } = ja(t), { pressProps: r } = Ot(t);
  return /* @__PURE__ */ d.createElement(
    "span",
    {
      ...j(r, a, {
        className: Ct.tag,
        tabIndex: -1
      })
    },
    /* @__PURE__ */ d.createElement("span", { className: Ct.label }, e.textValue),
    " ",
    /* @__PURE__ */ d.createElement(
      H,
      {
        className: Ct.icon,
        icon: "X",
        color: "currentcolor",
        size: "small",
        "aria-hidden": "true"
      }
    )
  );
}
const ls = "_trigger_13qgm_10", ss = "_small_13qgm_28", ds = "_withLeftIcon_13qgm_37", cs = "_placeholder_13qgm_73", fs = "_tagList_13qgm_83", ms = "_chevron_13qgm_92", We = {
  trigger: ls,
  small: ss,
  withLeftIcon: ds,
  placeholder: cs,
  tagList: fs,
  chevron: ms
}, hs = d.forwardRef(
  ({
    icon: e,
    placeholder: t,
    size: a,
    state: r,
    valueProps: n = {},
    ...u
  }, i) => {
    const { autoFocus: o, isDisabled: l } = u, s = d.useRef(null), f = l ? Qe.$500 : Qe.$800, { buttonProps: c, isPressed: $ } = Ho(u, s), { focusProps: C, isFocusVisible: w, isFocused: y } = li({
      autoFocus: o
    }), { hoverProps: b, isHovered: A } = ja({ isDisabled: l }), g = a ? ie(a) : void 0;
    return /* @__PURE__ */ d.createElement(
      "button",
      {
        ...j(c, C, b, {
          autoFocus: o
        }),
        className: We.trigger,
        "data-pressed": $ || void 0,
        "data-hovered": A || void 0,
        "data-focused": y || void 0,
        "data-focus-visible": w || void 0,
        "data-open": r.isOpen || void 0,
        ref: i
      },
      !!e && /* @__PURE__ */ d.createElement(H, { icon: e, size: g, color: f }),
      r.selectedItems.length > 0 ? /* @__PURE__ */ d.createElement("span", { className: We.tagList }, r.selectedItems.map((x) => /* @__PURE__ */ d.createElement(
        os,
        {
          onPress: () => r.selectionManager.toggleSelection(x.key),
          item: x,
          key: x.key
        }
      ))) : /* @__PURE__ */ d.createElement(
        "span",
        {
          ...n,
          "data-placeholder": "true",
          className: We.placeholder
        },
        t
      ),
      /* @__PURE__ */ d.createElement(
        H,
        {
          className: We.chevron,
          icon: "Chevron",
          size: 22,
          color: f
        }
      )
    );
  }
), $s = "_panel_pl0qv_4", ys = "_listbox_pl0qv_22", Ma = {
  panel: $s,
  listbox: ys
}, pu = d.forwardRef(
  ({ children: e, listBoxRef: t, listBoxProps: a, ...r }, n) => {
    r.className = K(r, Ma.panel);
    const u = K(
      a ?? {},
      Ma.listbox
    );
    return /* @__PURE__ */ d.createElement(Ta, { ...r, ref: n }, /* @__PURE__ */ d.createElement(
      si,
      {
        ...a,
        className: u,
        ref: t
      },
      e
    ));
  }
), bs = "_select_j5noh_10", wt = {
  select: bs
};
function hd({
  label: e,
  helpText: t,
  icon: a,
  size: r = "large",
  labelTextSize: n = r,
  error: u,
  isInvalid: i,
  shouldClosePanel: o,
  onClosePanel: l,
  ...s
}) {
  var V;
  s.className = K(
    s,
    wt.select,
    r === "small" ? wt.small : wt.large
  );
  const { isDisabled: f } = s, c = d.useRef(null), $ = d.useRef(null), C = d.useRef(null), w = d.useRef(null), y = qu(s), b = (Y) => {
    (Y.key === "Enter" || Y.key === " ") && y.toggle(), Y.key === "Escape" && y.close();
  }, { labelProps: A, triggerProps: g, valueProps: x, menuProps: E, descriptionProps: F } = Ju(
    {
      ...s,
      onKeyDown: ii(b, s.onKeyDown)
    },
    y,
    $
  ), { children: _, placeholder: B, items: I, onSelectionChange: R, ...m } = s, h = (Y) => Y ? y.open() : y.close(), v = (V = c.current) == null ? void 0 : V.getBoundingClientRect(), L = {
    isInvalid: i || !1,
    validationErrors: u ? [u] : [],
    validationDetails: ps()
  };
  return q(() => {
    o && y.isOpen && (y.close(), l && l());
  }, [o, y, l]), /* @__PURE__ */ d.createElement("div", { ...m, ref: c }, /* @__PURE__ */ d.createElement(
    Hu,
    {
      autoComplete: s.autoComplete,
      isDisabled: f,
      label: e,
      name: s.name,
      state: y,
      triggerRef: $
    }
  ), !!e && /* @__PURE__ */ d.createElement(De, { size: n, ...A }, e), !!t && /* @__PURE__ */ d.createElement(
    pe,
    {
      size: n,
      slot: "description",
      ...F
    },
    t
  ), /* @__PURE__ */ d.createElement(
    hs,
    {
      ...g,
      icon: a,
      placeholder: B,
      size: r,
      valueProps: x,
      state: y,
      "data-invalid": i || void 0
    }
  ), /* @__PURE__ */ d.createElement(Pu.Provider, { value: y }, /* @__PURE__ */ d.createElement(ku.Provider, { value: y }, /* @__PURE__ */ d.createElement(Va.Provider, { value: L }, /* @__PURE__ */ d.createElement(
    pu,
    {
      triggerRef: c,
      ref: w,
      listBoxRef: C,
      isOpen: y.isOpen,
      listBoxProps: j(E, {
        items: I,
        selectionMode: "multiple",
        disallowEmptySelection: !1
      }),
      onOpenChange: h,
      style: { "--trigger-width": `${v == null ? void 0 : v.width}px` }
    },
    _
  ), !!u && /* @__PURE__ */ d.createElement(Be, { size: n, error: u })))));
}
const ps = () => ({
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: !1,
  valueMissing: !1
}), Ds = "_radio_zkwey_4", vs = "_bubble_zkwey_18", gs = "_selectbox_zkwey_25", Bt = {
  radio: Ds,
  bubble: vs,
  selectbox: gs
};
function $d({ style: e, children: t, ...a }) {
  return a.className = K(
    a,
    Bt.radio,
    e === "Selectbox" && Bt.selectbox
  ), /* @__PURE__ */ d.createElement(_u, { ...a }, /* @__PURE__ */ d.createElement("span", { className: Bt.bubble }), /* @__PURE__ */ d.createElement(d.Fragment, null, t));
}
const xs = "_select_13ikp_10", Es = "_trigger_13ikp_16", Cs = "_small_13ikp_34", ws = "_withLeftIcon_13ikp_43", Bs = "_value_13ikp_79", As = "_chevron_13ikp_84", _e = {
  select: xs,
  trigger: Es,
  small: Cs,
  withLeftIcon: ws,
  value: Bs,
  chevron: As
};
function yd({
  label: e,
  helpText: t,
  error: a,
  items: r,
  icon: n,
  iconSize: u,
  size: i = "large",
  labelTextSize: o = i,
  onButtonPress: l = () => {
  },
  children: s,
  ...f
}) {
  f.className = K(
    f,
    _e.select,
    oe(i, _e)
  );
  const c = f.isDisabled ? Qe.$500 : Qe.$800;
  return /* @__PURE__ */ d.createElement(Iu, { ...f }, !!e && /* @__PURE__ */ d.createElement(De, { size: o }, e), !!t && /* @__PURE__ */ d.createElement(pe, { size: o, slot: "description" }, t), /* @__PURE__ */ d.createElement(it, { className: _e.trigger, onPress: l }, !!n && /* @__PURE__ */ d.createElement(
    H,
    {
      icon: n,
      size: ie(u || i),
      color: c
    }
  ), /* @__PURE__ */ d.createElement(Mu, { className: _e.value }), /* @__PURE__ */ d.createElement(
    H,
    {
      className: _e.chevron,
      icon: "Chevron",
      size: u ? ie(u) : "large",
      color: c
    }
  )), /* @__PURE__ */ d.createElement(pu, { listBoxProps: { items: r } }, s), /* @__PURE__ */ d.createElement(Be, { size: o, error: a }));
}
const Fs = "_field_104nf_10", Ps = "_input_104nf_17", ks = "_small_104nf_32", _s = "_withLeftIcon_104nf_41", Is = "_withRightIcon_104nf_79", Ms = "_icon_104nf_83", Ss = "_clearButton_104nf_94", te = {
  field: Fs,
  input: Ps,
  small: ks,
  withLeftIcon: _s,
  withRightIcon: Is,
  icon: Ms,
  clearButton: Ss
}, bd = d.forwardRef(function({
  label: t,
  helpText: a,
  size: r,
  labelTextSize: n = r,
  error: u,
  icon: i,
  placeholder: o,
  onClear: l,
  ...s
}, f) {
  const c = K(
    s,
    te.field,
    oe(r, te)
  ), $ = r ? ie(r) : "large";
  return /* @__PURE__ */ d.createElement(Ra, { ...s, className: c }, !!t && /* @__PURE__ */ d.createElement(De, { size: n }, t), !!a && /* @__PURE__ */ d.createElement(pe, { size: n, slot: "description" }, a), !!i && /* @__PURE__ */ d.createElement(
    H,
    {
      icon: i,
      size: $,
      className: fe(
        te.icon,
        $ === "small" && te.small
      )
    }
  ), /* @__PURE__ */ d.createElement(
    Nt,
    {
      className: fe(
        te.input,
        i && te.withLeftIcon,
        l && te.withRightIcon,
        i && $ === "small" && te.small
      ),
      ref: f,
      placeholder: o
    }
  ), l && /* @__PURE__ */ d.createElement(
    it,
    {
      type: "button",
      onPress: l,
      className: fe(
        te.clearButton,
        $ === "small" && te.small
      )
    },
    /* @__PURE__ */ d.createElement(H, { icon: "X", size: $ })
  ), /* @__PURE__ */ d.createElement(Be, { size: n, error: u }));
}), Rs = "_comboBox_1ywxq_10", Vs = "_typeaheadInput_1ywxq_26", Ts = "_input_1ywxq_34", Ns = "_small_1ywxq_51", Ls = "_withLeftIcon_1ywxq_60", Os = "_inputWithIcon_1ywxq_96", js = "_icon_1ywxq_100", Us = "_openButton_1ywxq_106", zs = "_chevronDownIcon_1ywxq_117", Zs = "_popover_1ywxq_126", Ks = "_listBox_1ywxq_146", Ys = "_listBoxItem_1ywxq_154", Ws = "_listBoxSection_1ywxq_165", qs = "_listBoxSectionHeader_1ywxq_173", Js = "_error_1ywxq_177", Z = {
  comboBox: Rs,
  typeaheadInput: Vs,
  input: Ts,
  small: Ns,
  withLeftIcon: Ls,
  inputWithIcon: Os,
  icon: js,
  openButton: Us,
  chevronDownIcon: zs,
  popover: Zs,
  listBox: Ks,
  listBoxItem: Ys,
  listBoxSection: Ws,
  listBoxSectionHeader: qs,
  error: Js
}, Hs = (e) => e.length > 0 && e[0].label !== void 0, Gs = (e) => e.map((t, a) => /* @__PURE__ */ d.createElement(Vu, { key: a, className: Z.listBoxSection }, /* @__PURE__ */ d.createElement(Tu, { className: Z.listBoxSectionHeader }, t.label), Du(t.options))), Du = (e) => e.map((t) => /* @__PURE__ */ d.createElement(
  Nu,
  {
    key: `${t.value}-${t.text}`,
    id: t.value,
    className: Z.listBoxItem
  },
  t.text
));
function Qs({ placeholder: e, icon: t, hasSections: a }) {
  const r = Tt(Lu), n = (u) => {
    if (u.key === "Enter") {
      u.preventDefault(), u.stopPropagation();
      const i = [], o = a ? 1 : 0;
      for (const l of r.collection.getKeys()) {
        const s = r.collection.getItem(l);
        (s == null ? void 0 : s.level) === o && i.push({
          key: String(l),
          value: { level: s.level }
        });
      }
      i.length === 1 && (r.setSelectedKey(i[0].key), r.setOpen(!1));
    }
  };
  return /* @__PURE__ */ d.createElement(
    Nt,
    {
      placeholder: e,
      className: fe(Z.input, t && Z.inputWithIcon),
      onKeyDown: n
    }
  );
}
function pd({
  label: e,
  helpText: t,
  error: a,
  icon: r,
  defaultItems: n,
  placeholder: u,
  isDisabled: i,
  size: o = "large",
  labelTextSize: l = o,
  iconSize: s = o,
  popoverMaxHeight: f,
  ...c
}) {
  const $ = Hs(n);
  return c.className = K(
    c,
    Z.comboBox,
    oe(o, Z)
  ), /* @__PURE__ */ d.createElement(
    Su,
    {
      autoFocus: !1,
      ...c,
      menuTrigger: "focus",
      isDisabled: i,
      "data-dd-action-name": "TypeaheadSelect",
      "data-dd-privacy": "hidden",
      onSelectionChange: c.onSelectionChange
    },
    e && /* @__PURE__ */ d.createElement(De, { size: l }, e),
    t && /* @__PURE__ */ d.createElement(pe, { size: l, slot: "description" }, t),
    /* @__PURE__ */ d.createElement("div", { className: Z.typeaheadInput }, r && /* @__PURE__ */ d.createElement(H, { icon: r, className: Z.icon }), /* @__PURE__ */ d.createElement(
      Qs,
      {
        placeholder: u,
        icon: r,
        hasSections: $
      }
    ), /* @__PURE__ */ d.createElement(
      it,
      {
        "aria-label": "Open",
        className: Z.openButton,
        "data-testid": "typeahead-select-button"
      },
      /* @__PURE__ */ d.createElement(
        H,
        {
          className: Z.chevronDownIcon,
          icon: "Chevron",
          size: s ? ie(s) : "large"
        }
      )
    )),
    /* @__PURE__ */ d.createElement(
      Be,
      {
        size: l,
        error: a,
        className: Z.error
      }
    ),
    /* @__PURE__ */ d.createElement(
      Ta,
      {
        className: Z.popover,
        "data-dd-action-name": "Popover",
        "data-dd-privacy": "hidden",
        maxHeight: f
      },
      /* @__PURE__ */ d.createElement(Ru, { className: Z.listBox }, $ ? Gs(n) : Du(n))
    )
  );
}
export {
  Wl as DropzoneDefaultIcon,
  ql as DropzoneDefaultText,
  Jl as DropzoneDefaultValidator,
  dd as RulaCheckbox,
  cd as RulaCreditCardField,
  fd as RulaDateInput,
  Be as RulaErrorMessage,
  md as RulaFileDropzone,
  pe as RulaHelpText,
  De as RulaLabel,
  hd as RulaMultiSelect,
  $d as RulaRadioBtn,
  yd as RulaSingleSelect,
  bd as RulaTextField,
  pd as RulaTypeaheadSelect
};
